/*! AtatusJs - v4.6.3 - 2024-10-09
* Copyright (c) 2024 Atatus */
!function () {
  "undefined" != typeof window && (!function (a) {
    function b(a, b) {
      return Object.prototype.hasOwnProperty.call(a, b);
    }
    function c(a) {
      return "undefined" == typeof a;
    }
    if (a) {
      var d = {},
        e = a.TraceKit,
        f = [].slice,
        g = "?";
      d.noConflict = function () {
        return a.TraceKit = e, d;
      }, d.wrap = function (a) {
        function b() {
          try {
            return a.apply(this, arguments);
          } catch (b) {
            throw d.report(b), b;
          }
        }
        try {
          if ("function" != typeof a || !a.apply) return a;
        } catch (c) {
          return a;
        }
        return b;
      }, d.report = function () {
        function c(a) {
          h(), m.push(a);
        }
        function e(a) {
          for (var b = m.length - 1; b >= 0; --b) m[b] === a && m.splice(b, 1);
        }
        function f(a, c, e) {
          var f = null;
          if (!c || d.collectWindowErrors) {
            for (var g in m) if (b(m, g)) try {
              m[g](a, c, e);
            } catch (h) {
              f = h;
            }
            if (f) throw f;
          }
        }
        function g(a, b, c, e, g) {
          var h = null;
          if (o) d.computeStackTrace.augmentStackTraceWithInitialElement(o, b, c, a), i();else if (g) h = d.computeStackTrace(g), f(h, !0, g);else {
            var j = {
              url: b,
              line: c,
              column: e
            };
            j.func = d.computeStackTrace.guessFunctionName(j.url, j.line), j.context = d.computeStackTrace.gatherContext(j.url, j.line), h = {
              mode: "onerror",
              message: a,
              stack: [j]
            }, f(h, !0, null);
          }
          return k ? k.apply(this, arguments) : !1;
        }
        function h() {
          l !== !0 && (k = a.onerror, a.onerror = g, l = !0);
        }
        function i() {
          var a = o,
            b = n;
          o = null, n = null, f(a, !1, b);
        }
        function j(b) {
          if (o) {
            if (n === b) return;
            i();
          }
          var c = d.computeStackTrace(b);
          throw o = c, n = b, a.setTimeout(function () {
            n === b && i();
          }, c.incomplete ? 2e3 : 0), b;
        }
        var k,
          l,
          m = [],
          n = null,
          o = null;
        return j.subscribe = c, j.unsubscribe = e, j;
      }(), d.computeStackTrace = function () {
        function e(a) {
          return "string" != typeof a ? [] : "";
        }
        function f(c) {
          if ("string" != typeof c) return [];
          if (!b(w, c)) {
            var d = "",
              f = "";
            try {
              f = a.document.domain;
            } catch (g) {}
            var h = /(.*)\:\/\/([^:\/]+)([:\d]*)\/{0,1}([\s\S]*)/.exec(c);
            h && h[2] === f && (d = e(c)), w[c] = d ? d.split("\n") : [];
          }
          return w[c];
        }
        function h(a, b) {
          var d,
            e = /function ([^(]*)\(([^)]*)\)/,
            h = /['"]?([0-9A-Za-z$_]+)['"]?\s*[:=]\s*(function|eval|new Function)/,
            i = "",
            j = 10,
            k = f(a);
          if (!k.length) return g;
          for (var l = 0; j > l; ++l) if (i = k[b - l] + i, !c(i)) {
            if (d = h.exec(i)) return d[1];
            if (d = e.exec(i)) return d[1];
          }
          return g;
        }
        function i(a, b) {
          var e = f(a);
          if (!e.length) return null;
          var g = [],
            h = Math.floor(d.linesOfContext / 2),
            i = h + d.linesOfContext % 2,
            j = Math.max(0, b - h - 1),
            k = Math.min(e.length, b + i - 1);
          b -= 1;
          for (var l = j; k > l; ++l) c(e[l]) || g.push(e[l]);
          return g.length > 0 ? g : null;
        }
        function j(a) {
          return a.replace(/[\-\[\]{}()*+?.,\\\^$|#]/g, "\\$&");
        }
        function k(a) {
          return j(a).replace("<", "(?:<|&lt;)").replace(">", "(?:>|&gt;)").replace("&", "(?:&|&amp;)").replace('"', '(?:"|&quot;)').replace(/\s+/g, "\\s+");
        }
        function l(a, b) {
          for (var c, d, e = 0, g = b.length; g > e; ++e) if ((c = f(b[e])).length && (c = c.join("\n"), d = a.exec(c))) return {
            url: b[e],
            line: c.substring(0, d.index).split("\n").length,
            column: d.index - c.lastIndexOf("\n", d.index) - 1
          };
          return null;
        }
        function m(a, b, c) {
          var d,
            e = f(b),
            g = new RegExp("\\b" + j(a) + "\\b");
          return c -= 1, e && e.length > c && (d = g.exec(e[c])) ? d.index : null;
        }
        function n(b) {
          if (!c(a && a.document)) {
            for (var d, e, f, g, h = [a.location.href], i = a.document.getElementsByTagName("script"), m = "" + b, n = /^function(?:\s+([\w$]+))?\s*\(([\w\s,]*)\)\s*\{\s*(\S[\s\S]*\S)\s*\}\s*$/, o = /^function on([\w$]+)\s*\(event\)\s*\{\s*(\S[\s\S]*\S)\s*\}\s*$/, p = 0; p < i.length; ++p) {
              var q = i[p];
              q.src && h.push(q.src);
            }
            if (f = n.exec(m)) {
              var r = f[1] ? "\\s+" + f[1] : "",
                s = f[2].split(",").join("\\s*,\\s*");
              d = j(f[3]).replace(/;$/, ";?"), e = new RegExp("function" + r + "\\s*\\(\\s*" + s + "\\s*\\)\\s*{\\s*" + d + "\\s*}");
            } else e = new RegExp(j(m).replace(/\s+/g, "\\s+"));
            if (g = l(e, h)) return g;
            if (f = o.exec(m)) {
              var t = f[1];
              if (d = k(f[2]), e = new RegExp("on" + t + "=[\\'\"]\\s*" + d + "\\s*[\\'\"]", "i"), g = l(e, h[0])) return g;
              if (e = new RegExp(d), g = l(e, h)) return g;
            }
            return null;
          }
        }
        function o(a) {
          if (!a.stack) return null;
          for (var b, d, e = /^\s*at (.*?) ?\(((?:file|https?|blob|chrome-extension|native|webpack|eval).*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i, f = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)((?:file|https?|blob|chrome|webpack|\[native).*?)(?::(\d+))?(?::(\d+))?\s*$/i, j = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:ms-appx|https?|webpack|blob):.*?):(\d+)(?::(\d+))?\)?\s*$/i, k = a.stack.split("\n"), l = [], n = /^(.*) is undefined$/.exec(a.message), o = 0, p = k.length; p > o; ++o) {
            if (b = e.exec(k[o])) {
              var q = b[2] && -1 !== b[2].indexOf("native");
              d = {
                url: q ? null : b[2],
                func: b[1] || g,
                args: q ? [b[2]] : [],
                line: b[3] ? +b[3] : null,
                column: b[4] ? +b[4] : null
              };
            } else if (b = j.exec(k[o])) d = {
              url: b[2],
              func: b[1] || g,
              args: [],
              line: +b[3],
              column: b[4] ? +b[4] : null
            };else {
              if (!(b = f.exec(k[o]))) continue;
              d = {
                url: b[3],
                func: b[1] || g,
                args: b[2] ? b[2].split(",") : [],
                line: b[4] ? +b[4] : null,
                column: b[5] ? +b[5] : null
              };
            }
            !d.func && d.line && (d.func = h(d.url, d.line)), d.line && (d.context = i(d.url, d.line)), l.push(d);
          }
          return l.length ? (l[0] && l[0].line && !l[0].column && n ? l[0].column = m(n[1], l[0].url, l[0].line) : l[0].column || c(a.columnNumber) || (l[0].column = a.columnNumber + 1), {
            mode: "stack",
            name: a.name,
            message: a.message,
            stack: l
          }) : null;
        }
        function p(a) {
          var b = a.stacktrace;
          if (b) {
            for (var c, d = / line (\d+).*script (?:in )?(\S+)(?:: in function (\S+))?$/i, e = / line (\d+), column (\d+)\s*(?:in (?:<anonymous function: ([^>]+)>|([^\)]+))\((.*)\))? in (.*):\s*$/i, f = b.split("\n"), g = [], j = 0; j < f.length; j += 2) {
              var k = null;
              if ((c = d.exec(f[j])) ? k = {
                url: c[2],
                line: +c[1],
                column: null,
                func: c[3],
                args: []
              } : (c = e.exec(f[j])) && (k = {
                url: c[6],
                line: +c[1],
                column: +c[2],
                func: c[3] || c[4],
                args: c[5] ? c[5].split(",") : []
              }), k) {
                if (!k.func && k.line && (k.func = h(k.url, k.line)), k.line) try {
                  k.context = i(k.url, k.line);
                } catch (l) {}
                k.context || (k.context = [f[j + 1]]), g.push(k);
              }
            }
            return g.length ? {
              mode: "stacktrace",
              name: a.name,
              message: a.message,
              stack: g
            } : null;
          }
        }
        function q(c) {
          var d = c.message.split("\n");
          if (d.length < 4) return null;
          var e,
            g = /^\s*Line (\d+) of linked script ((?:file|https?|blob)\S+)(?:: in function (\S+))?\s*$/i,
            j = /^\s*Line (\d+) of inline#(\d+) script in ((?:file|https?|blob)\S+)(?:: in function (\S+))?\s*$/i,
            m = /^\s*Line (\d+) of function script\s*$/i,
            n = [],
            o = a && a.document && a.document.getElementsByTagName("script"),
            p = [];
          for (var q in o) b(o, q) && !o[q].src && p.push(o[q]);
          for (var r = 2; r < d.length; r += 2) {
            var s = null;
            if (e = g.exec(d[r])) s = {
              url: e[2],
              func: e[3],
              args: [],
              line: +e[1],
              column: null
            };else if (e = j.exec(d[r])) {
              s = {
                url: e[3],
                func: e[4],
                args: [],
                line: +e[1],
                column: null
              };
              var t = +e[1],
                u = p[e[2] - 1];
              if (u) {
                var v = f(s.url);
                if (v) {
                  v = v.join("\n");
                  var w = v.indexOf(u.innerText);
                  w >= 0 && (s.line = t + v.substring(0, w).split("\n").length);
                }
              }
            } else if (e = m.exec(d[r])) {
              var x = a.location.href.replace(/#.*$/, ""),
                y = new RegExp(k(d[r + 1])),
                z = l(y, [x]);
              s = {
                url: x,
                func: "",
                args: [],
                line: z ? z.line : e[1],
                column: null
              };
            }
            if (s) {
              s.func || (s.func = h(s.url, s.line));
              var A = i(s.url, s.line),
                B = A ? A[Math.floor(A.length / 2)] : null;
              s.context = A && B.replace(/^\s*/, "") === d[r + 1].replace(/^\s*/, "") ? A : [d[r + 1]], n.push(s);
            }
          }
          return n.length ? {
            mode: "multiline",
            name: c.name,
            message: d[0],
            stack: n
          } : null;
        }
        function r(a, b, c, d) {
          var e = {
            url: b,
            line: c
          };
          if (e.url && e.line) {
            a.incomplete = !1, e.func || (e.func = h(e.url, e.line)), e.context || (e.context = i(e.url, e.line));
            var f = / '([^']+)' /.exec(d);
            if (f && (e.column = m(f[1], e.url, e.line)), a.stack.length > 0 && a.stack[0].url === e.url) {
              if (a.stack[0].line === e.line) return !1;
              if (!a.stack[0].line && a.stack[0].func === e.func) return a.stack[0].line = e.line, a.stack[0].context = e.context, !1;
            }
            return a.stack.unshift(e), a.partial = !0, !0;
          }
          return a.incomplete = !0, !1;
        }
        function s(a, b) {
          for (var c, e, f, i = /function\s+([_$a-zA-Z\xA0-\uFFFF][_$a-zA-Z0-9\xA0-\uFFFF]*)?\s*\(/i, j = [], k = {}, l = !1, o = s.caller; o && !l; o = o.caller) if (o !== t && o !== d.report) {
            if (e = {
              url: null,
              func: g,
              args: [],
              line: null,
              column: null
            }, o.name ? e.func = o.name : (c = i.exec(o.toString())) && (e.func = c[1]), "undefined" == typeof e.func) try {
              e.func = c.input.substring(0, c.input.indexOf("{"));
            } catch (p) {}
            if (f = n(o)) {
              e.url = f.url, e.line = f.line, e.func === g && (e.func = h(e.url, e.line));
              var q = / '([^']+)' /.exec(a.message || a.description);
              q && (e.column = m(q[1], f.url, f.line));
            }
            k["" + o] ? l = !0 : k["" + o] = !0, j.push(e);
          }
          b && j.splice(0, b);
          var u = {
            mode: "callers",
            name: a.name,
            message: a.message,
            stack: j
          };
          return r(u, a.sourceURL || a.fileName, a.line || a.lineNumber, a.message || a.description), u;
        }
        function t(a, b) {
          var c = null;
          b = null == b ? 0 : +b;
          try {
            if (c = p(a)) return c;
          } catch (d) {
            if (v) throw d;
          }
          try {
            if (c = o(a)) return c;
          } catch (d) {
            if (v) throw d;
          }
          try {
            if (c = q(a)) return c;
          } catch (d) {
            if (v) throw d;
          }
          try {
            if (c = s(a, b + 1)) return c;
          } catch (d) {
            if (v) throw d;
          }
          return {
            mode: "failed"
          };
        }
        function u(a) {
          a = (null == a ? 0 : +a) + 1;
          try {
            throw new Error();
          } catch (b) {
            return t(b, a + 1);
          }
        }
        var v = !1,
          w = {};
        return t.augmentStackTraceWithInitialElement = r, t.guessFunctionName = h, t.gatherContext = i, t.ofCaller = u, t.getSource = f, t;
      }(), d.extendToAsynchronousCallbacks = function () {
        var b = function (b) {
          var c = a[b];
          a[b] = function () {
            var a = f.call(arguments),
              b = a[0];
            return "function" == typeof b && (a[0] = d.wrap(b)), c.apply ? c.apply(this, a) : c(a[0], a[1]);
          };
        };
        b("setTimeout"), b("setInterval");
      }, d.remoteFetching || (d.remoteFetching = !0), d.collectWindowErrors || (d.collectWindowErrors = !0), (!d.linesOfContext || d.linesOfContext < 1) && (d.linesOfContext = 11), a.TraceKit = d;
    }
  }("undefined" != typeof window ? window : global), function (a, b) {
    "use strict";

    if (a && a.event && a.event.add) {
      var c = a.event.add;
      a.event.add = function (d, e, f, g, h) {
        if ("function" != typeof f && "function" != typeof f.handler) return c.call(this, d, e, f, g, h);
        var i;
        return f.handler ? (i = f.handler, f.handler = b.wrap(f.handler)) : (i = f, f = b.wrap(f)), f.guid = i.guid ? i.guid : i.guid = a.guid++, c.call(this, d, e, f, g, h);
      };
      var d = a.fn.ready;
      a.fn.ready = function (a) {
        return d.call(this, b.wrap(a));
      };
      var e = a.ajax;
      a.ajax = function (c, d) {
        "object" == typeof c && (d = c, c = void 0), d = d || {};
        for (var f, g = ["complete", "error", "success"]; f = g.pop();) a.isFunction(d[f]) && (d[f] = b.wrap(d[f]));
        try {
          return c ? e.call(this, c, d) : e.call(this, d);
        } catch (h) {
          throw b.report(h), h;
        }
      };
    }
  }(window.jQuery, window.TraceKit), window.webVitals = function (a) {
    "use strict";

    var b,
      c,
      d,
      e,
      f,
      g = -1,
      h = function (a) {
        addEventListener("pageshow", function (b) {
          b.persisted && (g = b.timeStamp, a(b));
        }, !0);
      },
      i = function () {
        return window.performance && performance.getEntriesByType && performance.getEntriesByType("navigation")[0];
      },
      j = function () {
        var a = i();
        return a && a.activationStart || 0;
      },
      k = function (a, b) {
        var c = i(),
          d = "navigate";
        return g >= 0 ? d = "back-forward-cache" : c && (document.prerendering || j() > 0 ? d = "prerender" : document.wasDiscarded ? d = "restore" : c.type && (d = c.type.replace(/_/g, "-"))), {
          name: a,
          value: void 0 === b ? -1 : b,
          rating: "good",
          delta: 0,
          entries: [],
          id: "v3-".concat(Date.now(), "-").concat(Math.floor(8999999999999 * Math.random()) + 1e12),
          navigationType: d
        };
      },
      l = function (a, b, c) {
        try {
          if (PerformanceObserver.supportedEntryTypes.includes(a)) {
            var d = new PerformanceObserver(function (a) {
              Promise.resolve().then(function () {
                b(a.getEntries());
              });
            });
            return d.observe(Object.assign({
              type: a,
              buffered: !0
            }, c || {})), d;
          }
        } catch (a) {}
      },
      m = function (a, b, c, d) {
        var e, f;
        return function (g) {
          b.value >= 0 && (g || d) && ((f = b.value - (e || 0)) || void 0 === e) && (e = b.value, b.delta = f, b.rating = function (a, b) {
            return a > b[1] ? "poor" : a > b[0] ? "needs-improvement" : "good";
          }(b.value, c), a(b));
        };
      },
      n = function (a) {
        requestAnimationFrame(function () {
          return requestAnimationFrame(function () {
            return a();
          });
        });
      },
      o = function (a) {
        var b = function (b) {
          "pagehide" !== b.type && "hidden" !== document.visibilityState || a(b);
        };
        addEventListener("visibilitychange", b, !0), addEventListener("pagehide", b, !0);
      },
      p = function (a) {
        var b = !1;
        return function (c) {
          b || (a(c), b = !0);
        };
      },
      q = -1,
      r = function () {
        return "hidden" !== document.visibilityState || document.prerendering ? 1 / 0 : 0;
      },
      s = function (a) {
        "hidden" === document.visibilityState && q > -1 && (q = "visibilitychange" === a.type ? a.timeStamp : 0, u());
      },
      t = function () {
        addEventListener("visibilitychange", s, !0), addEventListener("prerenderingchange", s, !0);
      },
      u = function () {
        removeEventListener("visibilitychange", s, !0), removeEventListener("prerenderingchange", s, !0);
      },
      v = function () {
        return 0 > q && (q = r(), t(), h(function () {
          setTimeout(function () {
            q = r(), t();
          }, 0);
        })), {
          get firstHiddenTime() {
            return q;
          }
        };
      },
      w = function (a) {
        document.prerendering ? addEventListener("prerenderingchange", function () {
          return a();
        }, !0) : a();
      },
      x = [1800, 3e3],
      y = function (a, b) {
        b = b || {}, w(function () {
          var c,
            d = v(),
            e = k("FCP"),
            f = l("paint", function (a) {
              a.forEach(function (a) {
                "first-contentful-paint" === a.name && (f.disconnect(), a.startTime < d.firstHiddenTime && (e.value = Math.max(a.startTime - j(), 0), e.entries.push(a), c(!0)));
              });
            });
          f && (c = m(a, e, x, b.reportAllChanges), h(function (d) {
            e = k("FCP"), c = m(a, e, x, b.reportAllChanges), n(function () {
              e.value = performance.now() - d.timeStamp, c(!0);
            });
          }));
        });
      },
      z = [.1, .25],
      A = function (a, b) {
        b = b || {}, y(p(function () {
          var c,
            d = k("CLS", 0),
            e = 0,
            f = [],
            g = function (a) {
              a.forEach(function (a) {
                if (!a.hadRecentInput) {
                  var b = f[0],
                    c = f[f.length - 1];
                  e && a.startTime - c.startTime < 1e3 && a.startTime - b.startTime < 5e3 ? (e += a.value, f.push(a)) : (e = a.value, f = [a]);
                }
              }), e > d.value && (d.value = e, d.entries = f, c());
            },
            i = l("layout-shift", g);
          i && (c = m(a, d, z, b.reportAllChanges), o(function () {
            g(i.takeRecords()), c(!0);
          }), h(function () {
            e = 0, d = k("CLS", 0), c = m(a, d, z, b.reportAllChanges), n(function () {
              return c();
            });
          }), setTimeout(c, 0));
        }));
      },
      B = {
        passive: !0,
        capture: !0
      },
      C = new Date(),
      D = function (a, e) {
        b || (b = e, c = a, d = new Date(), G(removeEventListener), E());
      },
      E = function () {
        if (c >= 0 && d - C > c) {
          var a = {
            entryType: "first-input",
            name: b.type,
            target: b.target,
            cancelable: b.cancelable,
            startTime: b.timeStamp,
            processingStart: b.timeStamp + c
          };
          e.forEach(function (b) {
            b(a);
          }), e = [];
        }
      },
      F = function (a) {
        if (a.cancelable) {
          var b = (a.timeStamp > 1e12 ? new Date() : performance.now()) - a.timeStamp;
          "pointerdown" == a.type ? function (a, b) {
            var c = function () {
                D(a, b), e();
              },
              d = function () {
                e();
              },
              e = function () {
                removeEventListener("pointerup", c, B), removeEventListener("pointercancel", d, B);
              };
            addEventListener("pointerup", c, B), addEventListener("pointercancel", d, B);
          }(b, a) : D(b, a);
        }
      },
      G = function (a) {
        ["mousedown", "keydown", "touchstart", "pointerdown"].forEach(function (b) {
          return a(b, F, B);
        });
      },
      H = [100, 300],
      I = function (a, d) {
        d = d || {}, w(function () {
          var f,
            g = v(),
            i = k("FID"),
            j = function (a) {
              a.startTime < g.firstHiddenTime && (i.value = a.processingStart - a.startTime, i.entries.push(a), f(!0));
            },
            n = function (a) {
              a.forEach(j);
            },
            q = l("first-input", n);
          f = m(a, i, H, d.reportAllChanges), q && o(p(function () {
            n(q.takeRecords()), q.disconnect();
          })), q && h(function () {
            var g;
            i = k("FID"), f = m(a, i, H, d.reportAllChanges), e = [], c = -1, b = null, G(addEventListener), g = j, e.push(g), E();
          });
        });
      },
      J = 0,
      K = 1 / 0,
      L = 0,
      M = function (a) {
        a.forEach(function (a) {
          a.interactionId && (K = Math.min(K, a.interactionId), L = Math.max(L, a.interactionId), J = L ? (L - K) / 7 + 1 : 0);
        });
      },
      N = function () {
        return f ? J : performance.interactionCount || 0;
      },
      O = function () {
        "interactionCount" in performance || f || (f = l("event", M, {
          type: "event",
          buffered: !0,
          durationThreshold: 0
        }));
      },
      P = [200, 500],
      Q = 0,
      R = function () {
        return N() - Q;
      },
      S = [],
      T = {},
      U = function (a) {
        var b = S[S.length - 1],
          c = T[a.interactionId];
        if (c || S.length < 10 || a.duration > b.latency) {
          if (c) c.entries.push(a), c.latency = Math.max(c.latency, a.duration);else {
            var d = {
              id: a.interactionId,
              latency: a.duration,
              entries: [a]
            };
            T[d.id] = d, S.push(d);
          }
          S.sort(function (a, b) {
            return b.latency - a.latency;
          }), S.splice(10).forEach(function (a) {
            delete T[a.id];
          });
        }
      },
      V = function (a, b) {
        b = b || {}, w(function () {
          var c;
          O();
          var d,
            e = k("INP"),
            f = function (a) {
              a.forEach(function (a) {
                a.interactionId && U(a), "first-input" === a.entryType && !S.some(function (b) {
                  return b.entries.some(function (b) {
                    return a.duration === b.duration && a.startTime === b.startTime;
                  });
                }) && U(a);
              });
              var b,
                c = (b = Math.min(S.length - 1, Math.floor(R() / 50)), S[b]);
              c && c.latency !== e.value && (e.value = c.latency, e.entries = c.entries, d());
            },
            g = l("event", f, {
              durationThreshold: null !== (c = b.durationThreshold) && void 0 !== c ? c : 40
            });
          d = m(a, e, P, b.reportAllChanges), g && ("interactionId" in PerformanceEventTiming.prototype && g.observe({
            type: "first-input",
            buffered: !0
          }), o(function () {
            f(g.takeRecords()), e.value < 0 && R() > 0 && (e.value = 0, e.entries = []), d(!0);
          }), h(function () {
            S = [], Q = N(), e = k("INP"), d = m(a, e, P, b.reportAllChanges);
          }));
        });
      },
      W = [2500, 4e3],
      X = {},
      Y = function (a, b) {
        b = b || {}, w(function () {
          var c,
            d = v(),
            e = k("LCP"),
            f = function (a) {
              var b = a[a.length - 1];
              b && b.startTime < d.firstHiddenTime && (e.value = Math.max(b.startTime - j(), 0), e.entries = [b], c());
            },
            g = l("largest-contentful-paint", f);
          if (g) {
            c = m(a, e, W, b.reportAllChanges);
            var i = p(function () {
              X[e.id] || (f(g.takeRecords()), g.disconnect(), X[e.id] = !0, c(!0));
            });
            ["keydown", "click"].forEach(function (a) {
              addEventListener(a, function () {
                return setTimeout(i, 0);
              }, !0);
            }), o(i), h(function (d) {
              e = k("LCP"), c = m(a, e, W, b.reportAllChanges), n(function () {
                e.value = performance.now() - d.timeStamp, X[e.id] = !0, c(!0);
              });
            });
          }
        });
      },
      Z = [800, 1800],
      $ = function aa(a) {
        document.prerendering ? w(function () {
          return aa(a);
        }) : "complete" !== document.readyState ? addEventListener("load", function () {
          return aa(a);
        }, !0) : setTimeout(a, 0);
      },
      _ = function (a, b) {
        b = b || {};
        var c = k("TTFB"),
          d = m(a, c, Z, b.reportAllChanges);
        $(function () {
          var e = i();
          if (e) {
            var f = e.responseStart;
            if (0 >= f || f > performance.now()) return;
            c.value = Math.max(f - j(), 0), c.entries = [e], d(!0), h(function () {
              c = k("TTFB", 0), (d = m(a, c, Z, b.reportAllChanges))(!0);
            });
          }
        });
      };
    return a.CLSThresholds = z, a.FCPThresholds = x, a.FIDThresholds = H, a.INPThresholds = P, a.LCPThresholds = W, a.TTFBThresholds = Z, a.getCLS = A, a.getFCP = y, a.getFID = I, a.getINP = V, a.getLCP = Y, a.getTTFB = _, a.onCLS = A, a.onFCP = y, a.onFID = I, a.onINP = V, a.onLCP = Y, a.onTTFB = _, Object.defineProperty(a, "__esModule", {
      value: !0
    }), a;
  }({}), function (a, b, c, d) {
    function e() {
      try {
        C = null, o() && localStorage.removeItem(ia), D = null, Fa.createCookie(ja, "", -1);
      } catch (a) {
        Fa.log("Atatus Reset User", a);
      }
    }
    function f(a, b, c, d) {
      if (a) {
        C = {}, a && (C.id = "" + a), b && (C.email = "" + b), c && (C.name = "" + c), d && (C.anonymous = d);
        try {
          o() && localStorage.setItem(ia, JSON.stringify(C)), D = null, Fa.createCookie(ja, "", -1);
        } catch (e) {
          Fa.log("Atatus Set User: Invalid JSON object in LocalStorage", e);
        }
      }
    }
    function g() {
      try {
        var a;
        if (o() && (a = localStorage.getItem(ia)), a) C = JSON.parse(a), D = null;else {
          var b,
            c = Fa.readCookie(ja);
          c && (b = Fa.readCookieElement(c, "id")), b && "undefined" !== b ? D = b : (D = Fa.uuid4(), Fa.createCookie(ja, D));
        }
      } catch (d) {
        Fa.log("Atatus Get User: Invalid JSON object in LocalStorage", d);
      }
    }
    function h(a) {
      var b = a,
        c = a.split("//")[1];
      if (c) {
        var d = c.indexOf("?"),
          e = c.toString().substring(0, d),
          f = e.split("/").slice(0, 4).join("/"),
          g = e.substring(0, 48);
        b = f.length < g.length ? f : g, b !== e && (b += "..");
      }
      return b;
    }
    function i(a, b, c, e) {
      if (0 !== b.status && b.getAllResponseHeaders()) {
        var f = "AJAX Error: " + (b.statusText || "unknown") + " " + (c.type || "unknown") + " " + (h(c.url) || "unknown");
        Ja.send(e || a.type, {
          status: b.status,
          statusText: b.statusText,
          type: c.type,
          url: c.url,
          ajaxErrorMessage: f,
          contentType: c.contentType,
          requestData: c.data && c.data.slice ? c.data.slice(0, 10240) : d,
          responseData: b.responseText && b.responseText.slice ? b.responseText.slice(0, 10240) : d,
          activeTarget: a.target && a.target.activeElement && a.target.activeElement.outerHTML && a.target.activeElement.outerHTML.slice ? a.target.activeElement.outerHTML.slice(0, 10240) : d
        });
      }
    }
    function j(a) {
      if (Fa.log("Atatus: Caught unhandled promise rejection:", a), a) {
        var b = a.reason || "<no reason specified>";
        b && (b instanceof Error || b.message) ? Ja.notify(b) : (b = "object" == typeof b ? "<object>" : "function" == typeof b ? "<function>" : b, Ja.notify(new Error("UnhandledRejection: " + b)));
      }
    }
    function k() {
      "addEventListener" in a && a.addEventListener("unhandledrejection", j);
    }
    function l() {
      "removeEventListener" in a && a.removeEventListener("unhandledrejection", j);
    }
    function m() {
      return A && "" !== A ? !0 : (Fa.log("Atatus API key has not been configured, make sure you call atatus.config(yourApiKey)"), !1);
    }
    function n() {
      var c = b.documentElement,
        d = b.getElementsByTagName("body")[0],
        e = a.innerWidth || c.clientWidth || d.clientWidth,
        f = a.innerHeight || c.clientHeight || d.clientHeight;
      return {
        width: e,
        height: f
      };
    }
    function o() {
      try {
        return "localStorage" in a && null !== a.localStorage;
      } catch (b) {
        return !1;
      }
    }
    function p(a) {
      try {
        if (o() && localStorage.length < 50) {
          var b = new Date().toJSON(),
            c = "atatusjs=" + b + "=" + Fa.getRandomInt();
          "undefined" == typeof localStorage[c] && (localStorage[c] = a);
        } else Fa.log("Atatus: Reached local storage limit.");
      } catch (d) {
        Fa.log("Atatus: LocalStorage full, cannot save exception");
      }
    }
    function q() {
      try {
        if (o() && localStorage.length > 0) for (var a in localStorage) if ("atatusjs=" === a.substring(0, 9)) {
          try {
            var b = JSON.parse(localStorage[a]);
            "apikey" in b && t(la, b);
          } catch (c) {
            Fa.log("Atatus: Invalid JSON object in LocalStorage");
          }
          localStorage.removeItem(a);
        }
      } catch (c) {
        Fa.log("Atatus sendSavedErrors: LocalStorage read failed!", c);
      }
    }
    function r(a, c) {
      if (c = Fa.isObject(c) ? c : {}, !a || !a.stack || !a.stack.length) return void Fa.log("Atatus: Canceling send due to no stacktrace.");
      Fa.isObject(c.customData) || (c.customData = d), Fa.isArray(c.tags) || (c.tags = d);
      var e = c.customData && c.customData.ajaxErrorMessage || a.message;
      if (e && 0 === e.indexOf("Uncaught ") && (e = a.message.substring(9)), e = e || c.status || "Script error.", N && N.test(e)) return void Fa.log("Atatus: canceling send due to Script error or ignored errors.");
      e = e.substr(0, va);
      var f = [];
      a.stack && a.stack.length && Fa.forEach(a.stack, function (a, b) {
        Fa.endsWith(b.url, "/atatus.js") || Fa.endsWith(b.url, "/atatus-spa.js") || Fa.endsWith(b.url, "/atatus-spa.min.js") || Fa.endsWith(b.url, "/atatus.min.js") || f.push({
          ln: parseInt(b.line || 0),
          cn: parseInt(b.column || 0),
          f: b.url || "anonymous",
          m: b.func || "[anonymous]"
        });
      });
      var g = [a.name, e, JSON.stringify(f)].join("|");
      if (g === O) return void Fa.log("Atatus: canceling send due to duplicate errors");
      O = g;
      var h = c.customData;
      try {
        JSON.stringify(h);
      } catch (i) {
        var j = "Cannot add custom data; may contain circular reference";
        h = {
          error: j
        }, Fa.log("Atatus: " + j);
      }
      var k = Ia.getAllEvents();
      Ga.clear();
      var l = {
        "class": a.name,
        url: b.location.href,
        message: e,
        name: e,
        backTraces: f,
        breadCrumbs: k,
        customData: h || null,
        tags: c.tags,
        ts: new Date().getTime()
      };
      if ("function" == typeof Q && (l.groupingKey = Q(l)), "function" == typeof S) {
        var m = S(l);
        m && (delete l.name, s(l));
      } else delete l.name, s(l);
    }
    function s(a) {
      return G ? void Fa.log("Error Tracking is disabled.") : void t(la, {
        customData: B || null,
        errors: [a]
      });
    }
    function t(c, d) {
      if (m()) {
        if (!Ja._isAllowedUrl(location.href)) return void Fa.log("Atatus: canceling send due to not an allowed domain/url.");
        if (!d.ts) {
          var e = a.screen || n();
          d.ts = new Date().getTime(), d.apikey = A, d.request = {
            url: b.location.href,
            ua: navigator.userAgent,
            w: e.width,
            h: e.height
          }, d.connection = Da, d.tags = d.tags || $, d.user = C && C.id ? C : null, d.aid = D || null, d.sid = Ja.sessionId || "", d.v = E || "", d._v = Ja.VERSION || X || "";
        }
        if (R) {
          var f = R(d);
          if (!f) return void Fa.log("Atatus: canceling send due to false from beforeSend callback.");
        }
        if (P && P(d), Fa.log("Sending data to Atatus Receiver:", d), c === ma) w(c, d);else if (c === oa) {
          if (!d.sid) return void Fa.log("Atatus: canceling session send due to empty session id.");
          if (Ca.session >= ya) return void Fa.log("Atatus: Canceling session send. Reached maximum number of requests!");
          Ca.session += 1, y(c, d);
        } else if (c === pa) {
          if (Ca.spa >= Aa) return void Fa.log("Atatus: Canceling SPA send. Reached maximum number of requests!");
          Ca.spa += 1, Ca.ajax = 0, y(c, d);
        } else if (c === ra) {
          if (Ca.webvitals >= Ba) return void Fa.log("Atatus: Canceling web vitals send. Reached maximum number of requests!");
          Ca.webvitals += 1, z(c, d);
        } else {
          if (c === la) {
            if (Ca.error >= wa) return void Fa.log("Atatus: Canceling error send. Reached maximum number of requests!");
            Ca.error += 1;
          } else if (c === na) {
            if (Ca.ajax >= xa) return void Fa.log("Atatus: Canceling AJAX send. Reached maximum number of requests!");
            Ca.ajax += 1;
          } else if (c === qa) {
            if (Ca.txn >= za) return void Fa.log("Atatus: Canceling transaction send. Reached maximum number of requests!");
            Ca.txn += 1;
          }
          v(c, d);
        }
      }
    }
    function u(a) {
      return "apikey=" + a.apikey + "&v=" + a._v;
    }
    function v(a, b) {
      var c = ka + a + "?data=" + encodeURIComponent(JSON.stringify(b)) + "&" + u(b);
      if (c.length > sa) return void Fa.log("Atatus: Canceling request send due to large payload size.");
      var d = new Image();
      d.crossOrigin = "anonymous", d.onload = function () {
        q();
      }, d.onerror = d.onabort = function () {
        ea && a === la && p(JSON.stringify(b));
      }, d.src = c;
    }
    function w(a, c) {
      var d = b.createElement("script"),
        e = ka + a + "?data=" + encodeURIComponent(JSON.stringify(c)) + "&callback=atatus._setFeatures&" + u(c);
      d.type = "text/javascript", d.src = e;
      var f = b.getElementsByTagName("script")[0];
      f.parentNode.insertBefore(d, f);
    }
    function x(b, c) {
      var d;
      return d = new a.XMLHttpRequest(), "withCredentials" in d ? d.open(b, c, !0) : a.XDomainRequest && (c = Fa.getTargetUrl(c), d = new a.XDomainRequest(), d.open(b, c)), d.timeout = 1e4, d;
    }
    function y(b, c) {
      var d = ka + b + "?" + u(c),
        e = x("POST", d);
      return e ? ("function" == typeof e.setRequestHeader && e.setRequestHeader("Content-Type", "application/json;charset=UTF-8"), "withCredentials" in e ? (e.onreadystatechange = function () {
        4 !== e.readyState;
      }, e.onload = function () {
        Fa.log("Sent data to Atatus. Status - " + e.status);
      }) : a.XDomainRequest && (e.ontimeout = function () {}, e.onload = function () {
        Fa.log("Sent data to Atatus. Status - " + e.status);
      }), e.onerror = function () {
        Fa.log("Failed to send to Atatus. Status - " + e.status);
      }, void e.send(JSON.stringify(c))) : void Fa.log("XHR is not supported!");
    }
    function z(b, c) {
      var d = "[object Navigator]" === Object.prototype.toString.call(a && a.navigator),
        e = d && "function" == typeof a.navigator.sendBeacon;
      if (e) {
        var f = a.navigator.sendBeacon.bind(a.navigator),
          g = ka + b;
        return f(g, JSON.stringify(c));
      }
      v(b, c);
    }
    var A,
      B,
      C,
      D,
      E,
      F,
      G,
      H,
      I,
      J,
      K,
      L,
      M,
      N,
      O,
      P,
      Q,
      R,
      S,
      T,
      U,
      V,
      W,
      X = "4.6.3",
      Y = a.TraceKit.noConflict(),
      Z = a.atatus,
      $ = [],
      _ = !1,
      aa = [],
      ba = [],
      ca = [],
      da = !1,
      ea = !1,
      fa = !1,
      ga = !0,
      ha = !1,
      ia = "atatus-user",
      ja = "atatus-aid",
      ka = "https://bm-rx.atatus.com",
      la = "/track/browser/errors",
      ma = "/track/browser/perf/pageload",
      na = "/track/browser/perf/ajax",
      oa = "/track/browser/perf/session",
      pa = "/track/browser/perf/spa",
      qa = "/track/browser/perf/txn",
      ra = "/track/browser/perf/webvitals",
      sa = 4e4,
      ta = 10,
      ua = 500,
      va = 1e3,
      wa = 20,
      xa = 5,
      ya = 10,
      za = 100,
      Aa = 100,
      Ba = 3,
      Ca = {
        error: 0,
        ajax: 0,
        session: 0,
        txn: 0,
        spa: 0,
        webvitals: 0
      },
      Da = null,
      Ea = ["google-analytics.com", "mixpanel.com", "bam.nr-data.net", "br-rx.atatus.com", "bm-rx.atatus.com", "segment.io", "hotjar.io", "hotjar.com", "amplitude.com", "fullstory.com", "autopilothq.com", "smartlook.com", "charmerly.com", "googleapis.com", "logrocket.io", "taboola.com", "sentry.io", "doubleclick.net", "logentries.com", "rb-collector.com", "js.hs-banner.com", "clarity.ms", "lr-ingest.io", "collector.replaybird.com", "rum.browser-intake-datadoghq.com"];
    c && (W = c(b));
    var Fa = {
        isBoolean: function (a) {
          return "undefined" != typeof a && "boolean" == typeof a;
        },
        isString: function (a) {
          return "string" == typeof a;
        },
        isNumber: function (a) {
          return "number" == typeof a;
        },
        isFunction: function (a) {
          return "function" == typeof a;
        },
        isArray: function (a) {
          return "[object Array]" === Object.prototype.toString.call(a);
        },
        isObject: function (a) {
          return "[object Object]" === Object.prototype.toString.call(a);
        },
        serialize: function (a) {
          if (!a) return "";
          if (Fa.isString(a) || Fa.isNumber(a) || Fa.isBoolean(a) || Fa.isFunction(a)) return "" + a;
          if ("object" == typeof a) try {
            return JSON.stringify(a);
          } catch (b) {
            return "Unserializable Object";
          }
          return "";
        },
        endsWith: function (a, b) {
          return a && b ? -1 !== a.indexOf(b, a.length - b.length) : !1;
        },
        joinRegExp: function (a) {
          if (0 === a.length) return null;
          for (var b, c = [], d = 0, e = a.length; e > d; d++) b = a[d], Fa.isString(b) ? c.push(b.replace(/([.*+?^=!:${}()|\[\]\/\\])/g, "\\$1")) : b && b.source && c.push(b.source);
          return new RegExp(c.join("|"), "i");
        },
        getTargetUrl: function (b) {
          return a.XDomainRequest && da && (b = b.slice(6)), b;
        },
        now: function () {
          return new Date().getTime();
        },
        pad: function (a) {
          return a = String(a), 1 === a.length && (a = "0" + a), a;
        },
        merge: function (a, b) {
          var c,
            d = {};
          for (c in a) d[c] = a[c];
          for (c in b) d[c] = b[c];
          return d;
        },
        mergeArray: function (a, b) {
          return null != b ? a.concat(b) : a;
        },
        forEach: function (a, b) {
          for (var c = 0; c < a.length; c++) b.call(null, c, a[c]);
        },
        isEmpty: function (a) {
          for (var b in a) if (a.hasOwnProperty(b)) return !1;
          return !0;
        },
        getRandomInt: function () {
          return Math.floor(9007199254740992 * Math.random());
        },
        log: function (b, c) {
          _ && a.console && a.console.log && (a.console.log(b), c && a.console.log(c));
        },
        bind: function (a, b) {
          return function () {
            return a.apply(b, Array.prototype.slice.call(arguments));
          };
        },
        canAllowInsecureSubmissions: function () {
          var b = a.navigator.userAgent,
            c = b.match(/Trident\/([\d.]+)/),
            d = c && "7.0" === c[1] ? 11 : (b = b.match(/MSIE ([\d.]+)/)) ? parseInt(b[1], 10) : !1;
          return d && 9 >= d;
        },
        uuid4: function () {
          return "xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx".replace(/[xy]/g, function (a) {
            var b = 16 * Math.random() | 0,
              c = "x" === a ? b : 3 & b | 8;
            return c.toString(16);
          });
        },
        addEventListener: function (b, c, d) {
          return "undefined" != typeof a.attachEvent ? a.attachEvent("on" + b, c) : a.addEventListener ? a.addEventListener(b, c, d) : void 0;
        },
        arrayFromObject: function (a) {
          var b = [];
          for (var c in a) a.hasOwnProperty(c) && b.push(a[c]);
          return b;
        },
        createCookie: function (a, c, d, e, f) {
          try {
            var g, h;
            if (d) {
              var i = new Date();
              i.setTime(i.getTime() + 60 * d * 60 * 1e3), g = "; expires=" + i.toGMTString();
            } else g = "";
            var j = e ? "; SameSite=Lax; secure" : "; SameSite=Lax",
              k = /[a-z0-9][a-z0-9-]+\.[a-z.]{2,6}$/i,
              l = "";
            if (f) {
              var m = b.location.hostname.match(k),
                n = m ? m[0] : "";
              l = n ? "; domain=." + n : "";
            }
            return h = new Date().toISOString(), b.cookie = a + "=id|" + c + "&timestamp|" + h + g + "; path=/" + l + j, h;
          } catch (o) {
            Fa.log("Creating cookie failed.", o);
          }
        },
        clearCookie: function (a) {
          this.createCookie(a, "", -1);
        },
        readCookieElement: function (a, b) {
          var c = a.split(/[|&]/);
          return "id" === b ? c[1] : "timestamp" === b ? c[3] : void 0;
        },
        readCookie: function (a) {
          try {
            for (var c = a + "=", d = b.cookie.split(";"), e = 0; e < d.length; e++) {
              for (var f = d[e]; " " === f.charAt(0);) f = f.substring(1, f.length);
              if (0 === f.indexOf(c)) return f.substring(c.length, f.length);
            }
            return null;
          } catch (g) {
            Fa.log("Reading cookie failed.", g);
          }
        }
      },
      Ga = {
        eventObject: {},
        all: function (a) {
          for (var b = this.getEventObject(a), c = [], d = 0; d < b.length; d++) c.push(b[d].value);
          return c;
        },
        clear: function () {
          for (var a in this.eventObject) this.eventObject.hasOwnProperty(a) && (this.eventObject[a].length = 0);
        },
        add: function (a, b) {
          var c = this.getEventObject(a),
            d = Fa.uuid4();
          return b.m ? b.m = b.m.length <= ua ? b.m : b.m.substr(0, ua) : b.e && (b.e = b.e.length <= ua ? b.e : b.e.substr(0, ua)), c.push({
            key: d,
            value: b
          }), this.truncateEventObject(a, ta), d;
        },
        get: function (a, b) {
          for (var c = this.getEventObject(a), d = 0; d < c.length; d++) if (c[d].key === b) return c[d].value;
          return !1;
        },
        getEventObject: function (a) {
          return this.eventObject[a] || (this.eventObject[a] = []), this.eventObject[a];
        },
        truncateEventObject: function (a, b) {
          var c = this.getEventObject(a);
          c.length > b && (this.eventObject[a] = c.slice(c.length - b));
        }
      },
      Ha = {
        attach: function (b, c, d, e, f) {
          b = b || a.console || {};
          for (var g = f || ["log", "debug", "info", "warn", "error"], h = g.pop(), i = function (a, b, d) {
              c && Ga.add("timeline", {
                ts: Fa.now(),
                c: "console",
                l: a,
                m: Fa.serialize(b)
              }), "error" === a && e && Ja.notify(new Error(b), d);
            }; h;) this.wrapConsoleMethod(b, h, d, i), h = g.pop();
        },
        wrapConsoleMethod: function (a, b, c, d) {
          var e = a[b],
            f = a;
          b in a && (a[b] = function () {
            var a = [].slice.call(arguments),
              g = "" + a.join(" "),
              h = {
                level: b,
                logger: "console"
              };
            d && d(b, g, h), e && c && Function.prototype.apply.call(e, f, a);
          });
        }
      },
      Ia = {
        attach: function () {
          var a = Fa.bind(this.onDocumentClicked, this),
            c = Fa.bind(this.onInputChanged, this);
          b.addEventListener ? (b.addEventListener("click", a, !0), b.addEventListener("blur", c, !0)) : b.attachEvent && (b.attachEvent("onclick", a), b.attachEvent("onfocusout", c));
        },
        writeUserEvent: function (a, b, c, d) {
          "password" === this.getElementType(a) && (c = void 0), Ga.add("timeline", {
            ts: Fa.now(),
            a: b,
            e: this.getOuterHTML(a),
            v: this.getValueKind(c, d)
          });
        },
        onDocumentClicked: function (a) {
          var b = this.getElementFromEvent(a);
          b && b.tagName && (this.isTarget(b, "a") || this.isTarget(b, "button") || this.isTarget(b, "input", ["button", "submit"]) ? this.writeUserEvent(b, "click") : this.isTarget(b, "input", ["checkbox", "radio"]) && this.writeUserEvent(b, "check", b.value, b.checked));
        },
        onInputChanged: function (a) {
          var b = this.getElementFromEvent(a);
          b && b.tagName && (this.isTarget(b, "textarea") ? this.writeUserEvent(b, "input", b.value) : this.isTarget(b, "select") && b.options && b.options.length ? this.onSelectInputChanged(b) : this.isTarget(b, "input") && !this.isTarget(b, "input", ["button", "submit", "hidden", "checkbox", "radio"]) && this.writeUserEvent(b, "input", b.value));
        },
        onSelectInputChanged: function (a) {
          if (a.multiple) {
            for (var b = 0; b < a.options.length; b++) if (a.options[b].selected) {
              this.writeUserEvent(a, "select", a.options[b].value);
              break;
            }
          } else 0 <= a.selectedIndex && a.options[a.selectedIndex] && this.writeUserEvent(a, "select", a.options[a.selectedIndex].value);
        },
        getElementFromEvent: function (a) {
          return a.target || b.elementFromPoint(a.clientX, a.clientY);
        },
        isTarget: function (a, b, c) {
          if (a.tagName.toLowerCase() !== b.toLowerCase()) return !1;
          if (!c) return !0;
          for (var d = this.getElementType(a), e = 0; e < c.length; e++) if (c[e] === d) return !0;
          return !1;
        },
        getElementType: function (a) {
          return (a.getAttribute("type") || "").toLowerCase();
        },
        getOuterHTML: function (a) {
          for (var b = "<" + a.tagName.toLowerCase(), c = a.attributes, d = 0, e = c.length; e > d; d++) {
            var f = c[d].name;
            "value" !== f.toLowerCase() && (b += " " + f + '="' + c[d].value + '"');
          }
          return b += " >";
        },
        getValueKind: function (a, b) {
          return null == a ? null : {
            length: a.length,
            checked: b,
            pattern: this.matchInputPattern(a)
          };
        },
        matchInputPattern: function (a) {
          return "" === a ? "empty" : /^[a-z0-9!#$%&'*+=?\^_`{|}~\-]+(?:\.[a-z0-9!#$%&'*+=?\^_`{|}~\-]+)*@(?:[a-z0-9](?:[a-z0-9\-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9\-]*[a-z0-9])?$/.test(a) ? "email" : /^(0?[1-9]|[12][0-9]|3[01])[\/\-](0?[1-9]|1[012])[\/\-]\d{4}$/.test(a) || /^(\d{4}[\/\-](0?[1-9]|1[012])[\/\-]0?[1-9]|[12][0-9]|3[01])$/.test(a) ? "date" : /^(?:(?:\+?1\s*(?:[.\-]\s*)?)?(?:\(\s*([2-9]1[02-9]|[2-9][02-8]1|[2-9][02-8][02-9])\s*\)|([2-9]1[02-9]|[2-9][02-8]1|[2-9][02-8][02-9]))\s*(?:[.\-]\s*)?)?([2-9]1[02-9]|[2-9][02-9]1|[2-9][02-9]{2})\s*(?:[.\-]\s*)?([0-9]{4})(?:\s*(?:#|x\.?|ext\.?|extension)\s*(\d+))?$/.test(a) ? "phone" : /^\s*$/.test(a) ? "whitespace" : /^\d*$/.test(a) ? "numeric" : "character";
        },
        getAllEvents: function () {
          return Ga.all("timeline");
        }
      },
      Ja = {
        VERSION: X,
        paintPerformance: {},
        noConflict: function () {
          return a.atatus = Z, Ja;
        },
        isConfigured: function () {
          return !!A;
        },
        config: function (b, c) {
          c = c || {}, A = b, Y.remoteFetching = !1, N = [], Ja.setCustomData(c.customData), Ja.setTags(c.tags), _ = !!c.debugMode, fa = !!c.reportAjaxErrors, ga = c.reportUnhandledRejections === d ? !0 : !!c.reportUnhandledRejections, ha = !!c.allowChromeExtension, F = !!c.disableBreadcrumbs, G = !!c.disableErrorTracking, L = !!c.disableRUM, I = !!c.disableAjaxMonitoring, J = c.disableSession === d ? !1 : c.disableSession, K = c.disableSPA === d ? !1 : c.disableSPA, V = c.urlMaxLength, da = Fa.canAllowInsecureSubmissions(), Ja.setIgnoreUrls(c.ignoreUrls), Ja.setWhitelistUrls(c.whitelistUrls), Ja.setAllowedDomains(c.allowedDomains), Ja.setVersion(c.version), Ja.enableOffline(c.enableOffline || c.offline), Ja.onBeforeSend(c.beforeSend), Ja.onBeforeErrorSend(c.beforeErrorSend), Ja.onTransformRouteUrl(c.transformRouteUrl), Ja.setGroupingKeyCallback(c.groupingKeyCallback), c.ignoreErrors && Fa.isArray(c.ignoreErrors) && (N = c.ignoreErrors), N.push(/^Script error\.?$/), N.push(/^Javascript error: Script error\.? on line 0$/), N = Fa.joinRegExp(N), q(), M = {
            enabled: !1,
            timeline: !0,
            display: !0,
            error: !0,
            levels: null
          }, Fa.isBoolean(c.console) && (M.enabled = c.console), Fa.isBoolean(c.consoleTimeline) && (M.timeline = c.consoleTimeline), Fa.isBoolean(c.consoleDisplay) && (M.display = c.consoleDisplay), Fa.isBoolean(c.consoleErrorNotify) && (M.error = c.consoleErrorNotify), Fa.isArray(c.consoleTimelineLevels) && (M.levels = c.consoleTimelineLevels), M.enabled && "console" in a && a.console.log && Ha.attach(a.console, M.timeline, M.display, M.error, M.levels), Ja.setHashRoutes(c.hashRoutes);
          var e = a.navigator.connection || a.navigator.mozConnection || a.navigator.webkitConnection;
          return e && (Da = {}, Da.dlk = e.downlink, Da.eft = e.effectiveType, Da.rtt = e.rtt, Da.type = e.type), Ja;
        },
        install: function () {
          if (!m()) return Ja;
          if (!ha && -1 !== b.location.href.indexOf("chrome-extension://")) return Ja;
          if (g(), F || Ia.attach(), G || (Y.report.subscribe(r), Y.extendToAsynchronousCallbacks(), W && fa && W.ajaxError(i), ga && k()), I || L || Ja.__attachAjaxHooks(), !J && !L && Ja.SessionTracking) {
            var c = function () {
              U = new Ja.SessionTracking(), U.attach();
            };
            a.addEventListener ? a.addEventListener("load", c) : a.attachEvent("onload", c);
          }
          return K || L || !Ja.spa || Ja.spa.init({
            logLevel: _ ? "debug" : "warn",
            urlMaxLength: V
          }), Ja;
        },
        uninstall: function () {
          return A = null, G || (Y.report.unsubscribe(r), W && fa && W.unbind("ajaxError", i), ga && l()), Ja;
        },
        setCustomData: function (a) {
          return a ? Fa.isObject(a) ? B = a : Fa.log("Custom data must be an object.") : B = null, Ja;
        },
        setTags: function (a) {
          return a ? Fa.isArray(a) ? $ = a : Fa.log("Tags must be an array of string.") : $ = [], Ja;
        },
        setHashRoutes: function (a) {
          return a ? (P = function (a) {
            if (a && a.request && a.request.url && (a.request.url = a.request.url.replace("/#/", "/").replace("#/", "/")), a && a.data && a.data[0] && a.data[0].spans) for (var b = 0; b < a.data.length; b++) a.data[b].n = (a.data[b].n || "").replace("/#/", "/").replace("#", "");
            if (a && a.slowestRoutes && a.slowestRoutes[0]) for (var c = 0; c < a.slowestRoutes.length; c++) a.slowestRoutes[c].n = (a.slowestRoutes[c].n || "").replace("/#/", "/").replace("#", "");
          }, Ja) : (P = null, Ja);
        },
        setIgnoreUrls: function (a) {
          return a && Fa.isArray(a) ? Array.prototype.push.apply(a, Ea) : a = Ea, ba = Fa.joinRegExp(a), Ja;
        },
        getIgnoreUrls: function () {
          return ba;
        },
        setWhitelistUrls: function (a) {
          return a && Fa.isArray(a) && (ca = Fa.joinRegExp(a)), Ja;
        },
        getWhitelistUrls: function () {
          return ca;
        },
        setAllowedDomains: function (a) {
          return a && Fa.isArray(a) && (aa = Fa.joinRegExp(a)), Ja;
        },
        getAllowedDomains: function () {
          return aa;
        },
        setUser: function (a, b, c, d) {
          return f(a, b, c, d), Ja;
        },
        resetUser: function () {
          return e(), Ja;
        },
        setVersion: function (a) {
          return a && (E = "" + a), Ja;
        },
        enableOffline: function (a) {
          return Fa.isBoolean(a) && (ea = a), Ja;
        },
        onBeforeSend: function (a) {
          return Fa.isFunction(a) && (R = a), Ja;
        },
        onBeforeErrorSend: function (a) {
          return Fa.isFunction(a) && (S = a), Ja;
        },
        onTransformRouteUrl: function (a) {
          return Fa.isFunction(a) && (T = a), Ja;
        },
        setGroupingKeyCallback: function (a) {
          return Fa.isFunction(a) && (Q = a), Ja;
        },
        setAPIEndpoint: function (a) {
          return ka = a, Ja;
        },
        getAPIEndpoint: function () {
          return ka;
        },
        getTransformRouteUrlFn: function () {
          return T;
        },
        init: function (a, b, c) {
          return c && (b = b || {}, b.customData = c), Ja.config(a, b);
        },
        withCustomData: function (a) {
          return Ja.setCustomData(a);
        },
        withTags: function (a) {
          return Ja.setTags(a);
        },
        attach: function () {
          return Ja.install();
        },
        detach: function () {
          return Ja.uninstall();
        },
        endSession: function () {
          return U && U.endSession(), Ja;
        },
        _setFeatures: function (a) {
          Fa.isObject(a) && (I = !!a.daj, J = !!a.dss, K = !!a.dspa, L = !!a.drum, G = !!a.derror, H = !!a.dtxn, a.error && Fa.log("Error in sending data to Atatus", a.error));
        },
        measureRoute: function (a) {
          return U && a && U.virtualPageLoaded(a), Ja;
        },
        leaveBreadcrumb: function (a, b) {
          return a ? (Ga.add("timeline", {
            ts: Fa.now(),
            c: "breadcrumb",
            l: b || "info",
            m: Fa.serialize(a)
          }), Ja) : void 0;
        },
        notify: function (a, b, c) {
          return "string" == typeof a ? void Fa.log("atatus.notify() was called with a string. Expected instance of Error.") : Ja.send(a, b, c);
        },
        sendPerf: function (a) {
          return L ? void Fa.log("RUM is disabled.") : t(ma, a);
        },
        sendAjaxPerf: function (a) {
          return L || I ? void Fa.log("AJAX monitoring is disabled.") : t(na, a);
        },
        sendSessionPerf: function (a) {
          return L || J ? void Fa.log("Session Tracking is disabled.") : t(oa, a);
        },
        sendSPAPerf: function (a) {
          return L || K ? void Fa.log("SPA Tracking is disabled.") : t(pa, a);
        },
        sendTxnPerf: function (a) {
          return L || H ? void Fa.log("Transaction monitoring is disabled.") : t(qa, a);
        },
        sendWebVitals: function (a) {
          return L ? void Fa.log("Web vitals is disabled.") : t(ra, a);
        },
        send: function (a, b, c) {
          try {
            r(Y.computeStackTrace(a), {
              customData: b,
              tags: c
            });
          } catch (d) {
            if (a !== d) throw d;
          }
          return Ja;
        },
        _isAllowedUrl: function (a) {
          return a = a || "", ba && ba.test && ba.test(a) ? !1 : ca && ca.test ? ca.test(a) ? !0 : !1 : aa && aa.test ? aa.test(a) ? !0 : !1 : !0;
        },
        _helper: Fa
      };
    a.atatus = Ja, "object" == typeof exports && "undefined" != typeof module ? (module.exports = Ja, "undefined" != typeof global && (global.atatus = Ja)) : "function" == typeof define && define.amd && ("object" == typeof require && require.load ? define(function () {
      return Ja;
    }) : define("atatus", function () {
      return Ja;
    }));
  }(window, document, window.jQuery), function (a, b, c, d) {
    function e(a) {
      a.pl <= 0 || (a.nt = a.nt > 0 ? a.nt : 0, a.dp = a.dp > 0 ? a.dp : 0, a.pr = a.pr > 0 ? a.pr : 0, c.sendPerf(a));
    }
    function f(b, c) {
      return "object" == typeof a.performance && (!b || b && typeof a.performance[b] === c);
    }
    function g(b) {
      if (!f("getEntriesByName", "function")) return b;
      var d = a.performance.getEntriesByName("first-paint");
      d.length > 0 && d[0].startTime > 0 ? b.fp = +d[0].startTime.toFixed(0) : a.performance.timing && a.performance.timing.msFirstPaint && (b.fp = +(a.performance.timing.msFirstPaint - a.performance.timing.fetchStart).toFixed(0));
      var e = a.performance.getEntriesByName("first-contentful-paint");
      return e.length > 0 && e[0].startTime > 0 && (b.fcp = +e[0].startTime.toFixed(0)), c.paintPerformance = {
        fp: b.fp,
        fcp: b.fcp
      }, b;
    }
    function h() {
      var b = a.performance || a.mozPerformance || a.msPerformance || a.webkitPerformance,
        c = b.timing;
      if (0 === c.loadEventEnd) return !1;
      clearInterval(l), l = null;
      var d = c.navigationStart;
      0 >= d && (d = c.fetchStart);
      var f = {};
      for (var h in m) f[m[h]] = -1, h in c && (c[h] <= 0 || (f[m[h]] = c[h] - d));
      var i = {
        nt: f.rps - f.ns,
        dp: f.dce - f.rps,
        pr: f.le - f.dce,
        pl: f.le - f.ns,
        timing: f
      };
      try {
        g(i);
      } catch (j) {}
      e(i);
    }
    function i() {
      if (!k || !k.bDone) return !1;
      clearInterval(l), l = !1;
      var a = k.getMeasures();
      if (null != a && null != a.backend && null != a.frontend && null != a["page load time"] && null != a["total load time"]) {
        var b = a.backend,
          c = a.backend + a.frontend,
          d = {
            nt: b,
            dp: c - b,
            pr: a["total load time"] - c,
            fe: a["total load time"] - b,
            pl: a["total load time"]
          };
        e(d);
      }
    }
    var j = new Date().getTime(),
      k = k || {};
    k.q = k.q || [], k.version = "0.3", k.targetOrigin = b.location.protocol + "//" + b.location.hostname, k.bPostMessage = !1, k.beaconUrl = k.beaconUrl || "/images/beacon.gif", k.autorun = !1, k.init = function () {
      if (k.bDone = !1, k.bUnloaded = !1, k.marks = {}, k.measures = {}, k.starts = {}, k.findStartTime(), k.addEventListener("beforeunload", k.beforeUnload, !1), k.addEventListener("pagehide", k.beforeUnload, !1), k.addEventListener("unload", k.beforeUnload, !1), k.processQ(), "complete" === b.readyState) {
        var c = a.performance || a.mozPerformance || a.msPerformance || a.webkitPerformance;
        c && "undefined" != typeof c.timing && "undefined" != typeof c.timing.loadEventEnd && (k.mark("firstbyte", c.timing.responseStart), k.mark("onload", c.timing.loadEventEnd)), k.done();
      } else k.addEventListener("load", k.onload, !1);
    }, k.processQ = function () {
      for (var a = k.q.length, b = 0; a > b; b++) {
        var c = k.q[b],
          d = c[0];
        "mark" === d ? k.mark(c[1], c[2]) : "measure" === d ? k.measure(c[1], c[2], c[3]) : "done" === d && k.done(c[1]);
      }
    }, k.mark = function (b, c) {
      return k.dprint("RUM_EPISODES.mark: " + b + ", " + c), b ? (k.marks[b] = parseInt(c || new Date().getTime()), k.bPostMessage && a.postMessage("RUM_EPISODES:mark:" + b + ":" + c, k.targetOrigin), void ("firstbyte" === b ? k.measure("backend", "starttime", "firstbyte") : "onload" === b ? (k.measure("frontend", "firstbyte", "onload"), k.measure("page load time", "starttime", "onload")) : "done" === b && k.measure("total load time", "starttime", "done"))) : void k.dprint("Error: markName is undefined in RUM_EPISODES.mark.");
    }, k.measure = function (b, c, d) {
      if (k.dprint("RUM_EPISODES.measure: " + b + ", " + c + ", " + d), !b) return void k.dprint("Error: episodeName is undefined in RUM_EPISODES.measure.");
      var e;
      if ("undefined" == typeof c) e = "number" == typeof k.marks[b] ? k.marks[b] : new Date().getTime();else if ("number" == typeof k.marks[c]) e = k.marks[c];else {
        if ("number" != typeof c) return void k.dprint("Error: unexpected startNameOrTime in RUM_EPISODES.measure: " + c);
        e = c;
      }
      var f;
      if ("undefined" == typeof d) f = new Date().getTime();else if ("number" == typeof k.marks[d]) f = k.marks[d];else {
        if ("number" != typeof d) return void k.dprint("Error: unexpected endNameOrTime in RUM_EPISODES.measure: " + d);
        f = d;
      }
      k.starts[b] = parseInt(e), k.measures[b] = parseInt(f - e), k.bPostMessage && a.postMessage("RUM_EPISODES:measure:" + b + ":" + e + ":" + f, k.targetOrigin);
    }, k.done = function (b) {
      k.bDone = !0, k.mark("done"), k.bPostMessage && a.postMessage("RUM_EPISODES:done", k.targetOrigin), "function" == typeof b && b();
    }, k.getMarks = function () {
      return k.marks;
    }, k.getMeasures = function () {
      return k.measures;
    }, k.getStarts = function () {
      return k.starts;
    }, k.findStartTime = function () {
      var a = k.findStartWebTiming() || k.findStartCookie();
      a && k.mark("starttime", a);
    }, k.findStartWebTiming = function () {
      var b,
        c = a.performance || a.mozPerformance || a.msPerformance || a.webkitPerformance;
      return c && "undefined" != typeof c.timing && "undefined" != typeof c.timing.navigationStart && (b = c.timing.navigationStart, k.dprint("RUM_EPISODES.findStartWebTiming: startTime = " + b)), b;
    }, k.findStartCookie = function () {
      try {
        for (var c = b.cookie.split(" "), e = 0; e < c.length; e++) if (0 === c[e].indexOf("RUM_EPISODES=")) {
          for (var f, g, h = c[e].substring("RUM_EPISODES=".length).split("&"), i = 0; i < h.length; i++) if (0 === h[i].indexOf("s=")) f = h[i].substring(2);else if (0 === h[i].indexOf("r=")) {
            var j = h[i].substring(2);
            j = j.replace(/;$/, ""), g = a.escape(b.referrer) === j;
          }
          if (g && f) return k.dprint("RUM_EPISODES.findStartCookie: startTime = " + f), f;
        }
      } catch (l) {}
      return d;
    }, k.beforeUnload = function () {
      try {
        if (k.bUnloaded) return;
        b.cookie = "RUM_EPISODES=s=" + Number(new Date()) + "&r=" + a.escape(b.location) + "; path=/", k.bUnloaded = !0;
      } catch (c) {}
    }, k.onload = function () {
      k.mark("onload"), k.done();
    }, k.addEventListener = function (b, c, d) {
      return "undefined" != typeof a.attachEvent ? a.attachEvent("on" + b, c) : a.addEventListener ? a.addEventListener(b, c, d) : void 0;
    }, k.dprint = function () {}, k.init();
    var l = null,
      m = {
        navigationStart: "ns",
        redirectStart: "rds",
        redirectEnd: "rde",
        unloadEventStart: "us",
        unloadEventEnd: "ue",
        fetchStart: "fs",
        domainLookupStart: "dls",
        domainLookupEnd: "dle",
        connectStart: "cs",
        secureConnectionStart: "scs",
        connectEnd: "ce",
        handshakeStart: "hs",
        requestStart: "rqs",
        responseStart: "rps",
        responseEnd: "rpe",
        domLoading: "dl",
        domInteractive: "di",
        domContentLoadedEventStart: "dcs",
        domContentLoadedEventEnd: "dce",
        domComplete: "dc",
        loadEventStart: "ls",
        loadEventEnd: "le"
      },
      n = a.performance || a.mozPerformance || a.msPerformance || a.webkitPerformance;
    n && "undefined" != typeof n.timing && "undefined" != typeof n.navigation ? l = setInterval(h, 100) : (k.mark("firstbyte", j), l = setInterval(i, 100));
  }(window, document, window.atatus), function (a, b, c) {
    b.SessionTracking = function () {
      function d(a) {
        b.sessionId = p.uuid4(), q.existingTimestamp = p.createCookie(q.cookieName, b.sessionId), a(!0);
      }
      function e() {
        var a;
        if (q.existingTimestamp) {
          var b = new Date(new Date() - s);
          a = q.existingTimestamp < b;
        }
        a && (q.stopSession = !0);
      }
      function f(a) {
        return Math.min(a, 3e5);
      }
      function g(a) {
        for (var b in a) isNaN(a[b]) && "string" != typeof a[b] ? a[b] = 0 : a[b] < 0 && (a[b] = 0);
        return a;
      }
      function h(b, c) {
        var d;
        return d = "object" == typeof a.performance && "function" == typeof a.performance.now ? a.performance.now() : 0, {
          du: Math.min(q.maxVirtualPageDuration, d - (b || c)),
          o: Math.min(q.maxVirtualPageDuration, d - c)
        };
      }
      function i(a) {
        var c = {
          du: a.loadEventEnd - a.navigationStart,
          s: a.fetchStart
        };
        return a.domainLookupStart && a.domainLookupStart > 0 && (c.dls = a.domainLookupStart - a.fetchStart), a.domainLookupEnd && a.domainLookupEnd > 0 && (c.dle = a.domainLookupEnd - a.fetchStart), a.connectStart && a.connectStart > 0 && (c.cs = a.connectStart - a.fetchStart), a.connectEnd && a.connectEnd > 0 && (c.ce = a.connectEnd - a.fetchStart), a.responseStart && a.responseStart > 0 && (c.rps = a.responseStart - a.fetchStart), a.responseEnd && a.responseEnd > 0 && (c.rpe = a.responseEnd - a.fetchStart), a.domLoading && a.domLoading > 0 && (c.dl = a.domLoading - a.fetchStart), a.domInteractive && a.domInteractive > 0 && (c.di = a.domInteractive - a.fetchStart), a.domContentLoadedEventEnd && a.domContentLoadedEventEnd > 0 && (c.dce = a.domContentLoadedEventEnd - a.fetchStart), a.domComplete && a.domComplete > 0 && (c.dc = f(a.domComplete - a.fetchStart)), a.loadEventStart && a.loadEventStart > 0 && (c.ls = a.loadEventStart - a.fetchStart), a.loadEventEnd && a.loadEventEnd > 0 && (c.le = a.loadEventEnd - a.fetchStart), a.secureConnectionStart && a.secureConnectionStart > 0 && (c.scs = a.secureConnectionStart - a.connectStart - a.fetchStart, c.scs = c.scs > 0 ? c.scs : 0), c = g(c), b.paintPerformance && b.paintPerformance.fp && (c.fp = b.paintPerformance.fp, c.fcp = b.paintPerformance.fcp), c;
      }
      function j(a, b) {
        var c = {
          du: f(a.duration),
          s: b + a.fetchStart
        };
        return a.domainLookupStart && a.domainLookupStart > 0 && (c.dls = a.domainLookupStart - a.fetchStart), a.domainLookupEnd && a.domainLookupEnd > 0 && (c.dle = a.domainLookupEnd - a.fetchStart), a.connectStart && a.connectStart > 0 && (c.cs = a.connectStart - a.fetchStart), a.connectEnd && a.connectEnd > 0 && (c.ce = a.connectEnd - a.fetchStart), a.responseStart && a.responseStart > 0 && (c.rps = a.responseStart - a.fetchStart), a.responseEnd && a.responseEnd > 0 && (c.rpe = a.responseEnd - a.fetchStart), a.secureConnectionStart && a.secureConnectionStart > 0 && (c.scs = a.secureConnectionStart - a.connectStart - a.fetchStart, c.scs = c.scs > 0 ? c.scs : 0), c = g(c);
      }
      function k() {
        var b = a.location.pathname,
          c = a.location.protocol + "//" + a.location.host + b;
        return c.length > 800 && (c = c.substring(0, 800)), {
          u: c,
          t: i(a.performance.timing),
          g: "p"
        };
      }
      function l(b, c, d) {
        var e = a.location.protocol + "//" + a.location.host + b;
        return e.length > 800 && (e = e.substring(0, 800)), {
          u: e,
          t: h(c, d),
          g: "r"
        };
      }
      function m(b, c) {
        var d = b.name.split("?")[0];
        return d.length > 800 && (d = d.substring(0, 800)), {
          u: d,
          t: j(b, c ? 0 : a.performance.timing.navigationStart),
          g: "xmlhttprequest" === b.initiatorType || "fetch" === b.initiatorType ? "x" : "s",
          z: b.decodedBodySize || b.transferSize || 0
        };
      }
      function n(b, d) {
        if (a.performance !== c && a.performance.getEntriesByType) try {
          for (var e = a.performance.getEntriesByType("resource"), f = q.offset; f < e.length; f++) {
            var g = e[f].name.split("?")[0];
            0 !== g.indexOf(q.atatusHost) && (g.indexOf("favicon.ico") > 0 || 0 !== g.indexOf("about:blank") && ("j" !== g[0] || 1 !== g.indexOf("avascript:")) && 0 !== g.indexOf("chrome-extension://") && 0 !== g.indexOf("res://") && 0 !== g.indexOf("file://") && e[f].name && b.push(m(e[f], d)));
          }
          q.offset = e.length;
        } catch (h) {}
      }
      function o(b, d, e, f) {
        if (a.performance === c || a.performance.timing === c || a.performance.timing.fetchStart === c || isNaN(a.performance.timing.fetchStart)) return null;
        var g = [{
          rs: []
        }];
        if (d && (e && (f ? g[0].p = k() : g[0].rs.push(k())), n(g[0].rs)), b) {
          q.pendingVirtualPage && (g[0].r = q.pendingVirtualPage);
          var h = null == q.pendingVirtualPage;
          if (q.pendingVirtualPage = l(b, q.previousVirtualPageLoadTimestamp, q.initalStaticPageLoadTimestamp), !h && g.length > 0) return g;
        }
        return g;
      }
      var p = b._helper,
        q = this,
        r = {};
      b.sessionId = null, this.cookieName = "atatus-sid", this.virtualPage = null, this.heartBeatInterval = null, this.offset = 0, this.atatusHost = b.getAPIEndpoint(), this.maxVirtualPageDuration = 18e5;
      var s = 3e5;
      this.existingTimestamp = null, this.stopSession = !1, this.sendSessionPayload = function (a) {
        q.stopSession || b.sendSessionPerf(a);
      }, this.sendSPAPayload = function () {}, this.attach = function () {
        d(function (a) {
          setTimeout(function () {
            q.pageLoaded(a);
          }, 5e3);
        });
        var b = function () {
            var a = [{
              rs: []
            }];
            if (n(a[0].rs), a[0].rs.length > 0) {
              var b = {
                data: a
              };
              q.sendSessionPayload(b);
            }
          },
          c = function () {
            this.watchCookieTimestamp();
          }.bind(r),
          e = function () {
            "visible" === document.visibilityState && this.watchCookieTimestamp();
          }.bind(r);
        a.addEventListener ? (a.addEventListener("click", c), document.addEventListener("visibilitychange", e), a.addEventListener("beforeunload", b)) : a.attachEvent && document.attachEvent("onclick", c);
      }, this.pageLoaded = function (b) {
        q.sendPerformance(!0, !0, b), q.heartBeat(), q.initalStaticPageLoadTimestamp = "object" == typeof a.performance && "function" == typeof a.performance.now ? a.performance.now() : 0;
      }, this.endSession = function () {
        q.stopSession = !0, p.createCookie(q.cookieName, b.sessionId, -1);
      }, this.heartBeat = function () {
        q.heartBeatInterval = setInterval(function () {
          var a = [{
            rs: []
          }];
          if (n(a[0].rs, q.virtualPage), a[0].rs.length > 0) {
            var b = {
              data: a
            };
            q.sendSessionPayload(b);
          }
        }, 3e4);
      }, this.virtualPageLoaded = function (b) {
        var c = null == this.virtualPage;
        "string" == typeof b && (b.length > 0 && "/" !== b[0] && (b += "/"), b.length > 800 && (b = b.substring(0, 800)), this.virtualPage = b), c ? this.sendPerformance(!0, !1, !1) : this.sendPerformance(!1, !1, !1), "string" == typeof b && (this.previousVirtualPageLoadTimestamp = "object" == typeof a.performance && "function" == typeof a.performance.now ? a.performance.now() : 0);
      }, this.sendPerformance = function (a, b, c) {
        var d = o(this.virtualPage, a, b, c);
        if (d) {
          var e = {
            data: d
          };
          d[0].r ? q.sendSPAPayload(e) : d[0].rs.length > 0 && q.sendSessionPayload(e);
        }
      }, r.watchCookieTimestamp = e;
    };
  }(window, window.atatus), function (a, b, c) {
    c.__attachAjaxHooks = function () {
      var d = c._helper,
        e = {
          queue: [],
          batchSize: 25,
          processing: !1,
          bUnloaded: !1,
          push: function (a) {
            "string" == typeof a.url && (a.url.indexOf(".html") > 0 || -1 === a.url.indexOf("://") || !c._isAllowedUrl(a.url) || (this.queue.push(a), this.queue.length >= this.batchSize && this._processQueue()));
          },
          _processQueue: function () {
            if (!this.processing && this.queue.length) {
              this.processing = !0;
              try {
                for (var a = {}, b = {}, e = 0; e < this.queue.length; e++) {
                  var f,
                    g = this.queue[e],
                    h = parseInt(g.status) || 200;
                  if (h > 0) {
                    f = g.method + g.url;
                    var i = g.respAvailTime - g.sendTime,
                      j = g.respProcTime - g.respAvailTime,
                      k = g.receivedSize ? +g.receivedSize : 0,
                      l = g.sendSize ? +g.sendSize : 0;
                    0 > i && (i = 0), 0 > j && (j = 0), isNaN(k) && (k = 0), isNaN(l) && (l = 0);
                    var m = a[f];
                    m ? (m.st.push(h), m.rt.push(i), m.ct.push(j), m.rz.push(k), m.sz.push(l), m.ts.push(g.sendTime || new Date().getTime())) : a[f] = {
                      m: g.method,
                      u: g.url,
                      st: [h],
                      rt: [i],
                      ct: [j],
                      rz: [k],
                      sz: [l],
                      ts: [g.sendTime || new Date().getTime()]
                    };
                  }
                  if (h >= 400) {
                    f = g.method + h + g.url;
                    var n = b[f];
                    n && n.sc ? n.sc[h] ? n.sc[h]++ : n.sc[h] = 1 : (b[f] = {
                      m: g.method,
                      u: g.url,
                      sc: {}
                    }, b[f].sc[h] = 1);
                  }
                }
                var o = {
                  xhr: d.arrayFromObject(a),
                  xhrError: d.arrayFromObject(b)
                };
                c.sendAjaxPerf(o);
              } catch (p) {
                d.log("Error while processing queue: ", p);
              } finally {
                this.queue = [], this.processing = !1;
              }
            }
          },
          beforeUnload: function () {
            e.bUnloaded || (e._processQueue(), e.bUnloaded = !0);
          }
        };
      d.addEventListener("beforeunload", e.beforeUnload, !1), setInterval(function () {
        e._processQueue();
      }, 3e4);
      var f = {
        support: function (a) {
          return !a || "apply" in a;
        },
        around: function (a, b, c, e) {
          return a = a || function () {}, function () {
            var f,
              g = Array.prototype.slice.call(arguments);
            try {
              b && (f = b.apply(this, g));
            } catch (h) {
              d.log(e, h);
            }
            var i;
            try {
              i = a.apply(this, f || g);
            } finally {
              try {
                c && c.apply(this, g);
              } catch (h) {
                d.log(e, h);
              }
            }
            return i;
          };
        },
        before: function (a, b) {
          return f.around(a, b);
        },
        after: function (a, b) {
          return f.around(a, null, b);
        },
        timeout: function (a) {
          setTimeout(a, 0);
        },
        wrapAddEventListener: function () {
          return function (a, b) {
            if (("load" === a || "error" === a) && b && this._atrumXhrData) {
              var c;
              b.__atrumInterceptor ? c = b.__atrumInterceptor : f.support(b) ? (c = h.wrapXHR(b, this, "XHR.invokeEventListener"), b.__atrumInterceptor = c) : c = null;
              var d;
              return c && (d = Array.prototype.slice.call(arguments), d[1] = c), d;
            }
          };
        },
        wrapRemoveEventListener: function () {
          return function (a, b) {
            if (this._atrumXhrData) {
              var c = Array.prototype.slice.call(arguments);
              return b.__atrumInterceptor && (c[1] = b.__atrumInterceptor), c;
            }
          };
        },
        aroundWithHandleEvent: function (a, b, c, d) {
          var e = a;
          return a && "object" == typeof a && "toString" in a && "[xpconnect wrapped nsIDOMEventListener]" === a.toString() && "handleEvent" in a && (e = function () {
            a.handleEvent.apply(this, Array.prototype.slice.call(arguments));
          }), f.around(e, b, c, d);
        },
        getFullyQualifiedUrl: function (a) {
          var c = b.createElement("a");
          return c.href = a, c.href;
        }
      };
      if (a.XMLHttpRequest && a.XMLHttpRequest.prototype) {
        var g = a.XMLHttpRequest.prototype;
        if (!("open" in g && "send" in g)) return;
        if (!f.support(g.open) || !f.support(g.send)) return;
        var h = {};
        h.captureAjaxTimings = function (a) {
          var b = a._atrumXhrData;
          if (b) {
            var c = new Date().getTime();
            2 === a.readyState ? b.firstByteTime = b.firstByteTime || c : 4 === a.readyState && (b.respAvailTime = b.respAvailTime || c, b.firstByteTime = b.firstByteTime || c);
          }
        }, h.sendPayload = function (a, b) {
          b.receivedSize = 0, a.responseType && "text" !== a.responseType || "string" == typeof a.responseText && (b.receivedSize = a.responseText.length), b.status = a.status, e.push(b);
        }, h.wrapXHR = function (a, b, c) {
          return f.aroundWithHandleEvent(a, function () {
            h.captureAjaxTimings(this);
          }, function () {
            var a = b._atrumXhrData;
            if (a && 4 === b.readyState) {
              var c = new Date().getTime();
              a.respProcTime = a.respProcTime || c, h.sendPayload(b, a), delete b._atrumXhrData;
            }
          }, c);
        }, h.ajaxDone = function (a) {
          if (a._atrumXhrData) {
            var b = new Date().getTime() + 15e4,
              c = function () {
                h.captureAjaxTimings(a);
                var d = a._atrumXhrData;
                if (d) {
                  var e = new Date().getTime();
                  4 === a.readyState ? (d.respProcTime = d.respProcTime || e, h.sendPayload(a, d), delete a._atrumXhrData) : b > e ? setTimeout(c, 50) : delete a._atrumXhrData;
                }
              };
            c();
          }
        }, g.open = f.around(g.open, function () {
          var a = 1 <= arguments.length ? String(arguments[0]) : "",
            b = 2 <= arguments.length ? String(arguments[1]) : "";
          b = f.getFullyQualifiedUrl(b);
          var d = c._isAllowedUrl(b);
          d && (b = b && b.split("?")[0], this._atrumXhrData = {
            method: a,
            url: b,
            sendTime: null,
            sendSize: null,
            firstByteTime: null,
            respAvailTime: null,
            respProcTime: null,
            receivedSize: null,
            parentPhase: null
          });
        }, null, "XHR.open"), g.send = f.around(g.send, function () {
          var a = this,
            b = a._atrumXhrData;
          if (b) {
            var c = new Date().getTime();
            if (b.sendTime = b.sendTime || c, b.sendSize = 1 <= arguments.length && arguments[0] ? arguments[0].length || 0 : 0, a.onreadystatechange && "function" == typeof a.onreadystatechange) {
              var d = 0,
                e = function () {
                  if (4 === a.readyState) h.ajaxDone(a);else {
                    var b = null;
                    try {
                      b = a.onreadystatechange;
                    } catch (c) {
                      return void h.ajaxDone(a);
                    }
                    d++, b ? f.support(b) ? a.onreadystatechange = h.wrapXHR(b, a, "XHR.onReadyStateChange") : h.ajaxDone(a) : 5 > d ? f.timeout(e) : h.ajaxDone(a);
                  }
                };
              e();
            } else a.addEventListener("readystatechange", function () {
              4 === a.readyState && h.ajaxDone(a);
            });
          }
        }, null, "XHR.send"), "addEventListener" in g && "removeEventListener" in g && f.support(g.addEventListener) && f.support(g.removeEventListener) && (g.addEventListener = f.around(g.addEventListener, f.wrapAddEventListener(), null, "XHR.addEventListener"), g.removeEventListener = f.around(g.removeEventListener, f.wrapRemoveEventListener(), null, "XHR.removeEventListener"));
      }
      if ("fetch" in a && !a.fetch.polyfill) {
        var i = a.fetch;
        a.fetch = function (a) {
          return function () {
            for (var b = new Array(arguments.length), d = 0; d < b.length; ++d) b[d] = arguments[d];
            var f = b[0] && b[0].method || b[1] && b[1].method || "GET",
              g = "Unknown URL";
            "string" == typeof b[0] ? g = b[0] : b[0] && b[0].url && (g = b[0].url);
            var h = 0;
            b[1] && "string" == typeof b[1].body && (h = b[1].body.length);
            var i = {
              url: g,
              method: f,
              sendSize: h,
              receivedSize: 0,
              sendTime: new Date().getTime(),
              respAvailTime: 0,
              respProcTime: 0
            };
            return a.apply(this, b).then(function (a) {
              return i.respAvailTime = new Date().getTime(), c._isAllowedUrl(i.url) && (i.respProcTime = i.respAvailTime, i.status = a.status, a.headers && a.headers.get && (i.receivedSize = a.headers.get("Content-Length")), e.push(i)), a;
            })["catch"](function (a) {
              throw i.respAvailTime = new Date().getTime(), c._isAllowedUrl(i.url) && (i.respProcTime = i.respAvailTime, i.status = 408, i.receivedSize = 0, e.push(i)), a;
            });
          };
        }(i);
      }
    };
  }(window, document, window.atatus), function (a, b) {
    function c(a, c, d) {
      if (!(0 >= c)) {
        var e = {
          data: [{
            t: {
              n: a,
              s: d,
              t: {
                du: c
              }
            }
          }]
        };
        b.sendTxnPerf(e);
      }
    }
    function d(a) {
      return i + " " + a;
    }
    function e() {
      try {
        return "localStorage" in a && null !== a.localStorage;
      } catch (b) {
        return !1;
      }
    }
    function f(a) {
      var b = j.now();
      try {
        localStorage.setItem(d(a), b);
      } catch (c) {}
    }
    function g(a) {
      var b = null,
        c = d(a);
      try {
        b = localStorage.getItem(c), localStorage.removeItem(c);
      } catch (e) {}
      var f = 0;
      return b && (f = j.now() - b), f;
    }
    function h(a) {
      try {
        var b = d(a);
        localStorage.removeItem(b);
      } catch (c) {}
    }
    var i = "atatus.com/",
      j = b._helper,
      k = 1,
      l = 0;
    b.beginTransaction = function (a) {
      e() && f(a);
    }, b.endTransaction = function (a) {
      if (e()) {
        var b = g(a);
        c(a, b, k);
      }
    }, b.failTransaction = function (a) {
      if (e()) {
        var b = g(a);
        c(a, b, l);
      }
    }, b.cancelTransaction = function (a) {
      e() && h(a);
    }, b.recordTransaction = function (a, b, d) {
      e() && a && b && c(a, b, d === !1 ? l : k);
    };
  }(window, window.atatus), function (a, b) {
    function c(a) {
      a = a || {};
      var b = a.name && a.name.toLowerCase();
      b && a.value && (e[b] || f++, e[b] = a.value);
    }
    function d() {
      if (a.webVitals) {
        a.webVitals.onFID(c), a.webVitals.onFCP(c), a.webVitals.onTTFB(c), a.webVitals.onLCP(c), a.webVitals.onCLS(c, {
          reportAllChanges: !0
        }), a.webVitals.onINP(c, {
          reportAllChanges: !0
        });
        var b = a.performance && a.performance.timing;
        !e.ttfb && b && (e.ttfb = b.responseStart - b.navigationStart, e.ttfb && f++);
      }
    }
    var e = {},
      f = 0,
      g = !1,
      h = function () {
        !g && f > 0 && (g = !0, b.sendWebVitals(e));
      };
    "loading" !== document.readyState ? d() : document.addEventListener("DOMContentLoaded", function () {
      d();
    }), a.addEventListener("beforeunload", function () {
      h();
    });
  }(window, window.atatus), function (a, b) {
    a._atatusConfig && a._atatusConfig.apikey && b.config(a._atatusConfig.apikey, a._atatusConfig).install();
  }(window, window.atatus));
}();
!function (n) {
  var r = {};
  function i(t) {
    if (r[t]) return r[t].exports;
    var e = r[t] = {
      i: t,
      l: !1,
      exports: {}
    };
    return n[t].call(e.exports, e, e.exports, i), e.l = !0, e.exports;
  }
  i.m = n, i.c = r, i.d = function (t, e, n) {
    i.o(t, e) || Object.defineProperty(t, e, {
      enumerable: !0,
      get: n
    });
  }, i.r = function (t) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(t, "__esModule", {
      value: !0
    });
  }, i.t = function (e, t) {
    if (1 & t && (e = i(e)), 8 & t) return e;
    if (4 & t && "object" == typeof e && e && e.__esModule) return e;
    var n = Object.create(null);
    if (i.r(n), Object.defineProperty(n, "default", {
      enumerable: !0,
      value: e
    }), 2 & t && "string" != typeof e) for (var r in e) i.d(n, r, function (t) {
      return e[t];
    }.bind(null, r));
    return n;
  }, i.n = function (t) {
    var e = t && t.__esModule ? function () {
      return t.default;
    } : function () {
      return t;
    };
    return i.d(e, "a", e), e;
  }, i.o = function (t, e) {
    return Object.prototype.hasOwnProperty.call(t, e);
  }, i.p = "", i(i.s = 2);
}([function (t, e, n) {
  t.exports = function () {
    "use strict";

    function c(t) {
      return "function" == typeof t;
    }
    var n = Array.isArray ? Array.isArray : function (t) {
        return "[object Array]" === Object.prototype.toString.call(t);
      },
      r = 0,
      e = void 0,
      i = void 0,
      a = function (t, e) {
        h[r] = t, h[r + 1] = e, 2 === (r += 2) && (i ? i(v) : y());
      },
      t = "undefined" != typeof window ? window : void 0,
      o = t || {},
      s = o.MutationObserver || o.WebKitMutationObserver,
      u = "undefined" == typeof self && "undefined" != typeof process && "[object process]" === {}.toString.call(process),
      d = "undefined" != typeof Uint8ClampedArray && "undefined" != typeof importScripts && "undefined" != typeof MessageChannel;
    function f() {
      var t = setTimeout;
      return function () {
        return t(v, 1);
      };
    }
    var h = new Array(1e3);
    function v() {
      for (var t = 0; t < r; t += 2) {
        var e = h[t],
          n = h[t + 1];
        e(n), h[t] = void 0, h[t + 1] = void 0;
      }
      r = 0;
    }
    var l,
      p,
      g,
      m,
      y = void 0;
    function _(t, e) {
      var n = this,
        r = new this.constructor(T);
      void 0 === r[w] && j(r);
      var i = n._state;
      if (i) {
        var o = arguments[i - 1];
        a(function () {
          return F(i, r, o, n._result);
        });
      } else A(n, r, t, e);
      return r;
    }
    function S(t) {
      if (t && "object" == typeof t && t.constructor === this) return t;
      var e = new this(T);
      return I(e, t), e;
    }
    y = u ? function () {
      return process.nextTick(v);
    } : s ? (p = 0, g = new s(v), m = document.createTextNode(""), g.observe(m, {
      characterData: !0
    }), function () {
      m.data = p = ++p % 2;
    }) : d ? ((l = new MessageChannel()).port1.onmessage = v, function () {
      return l.port2.postMessage(0);
    }) : void 0 === t ? function () {
      try {
        var t = Function("return this")().require("vertx");
        return void 0 === (e = t.runOnLoop || t.runOnContext) ? f() : function () {
          e(v);
        };
      } catch (t) {
        return f();
      }
    }() : f();
    var w = Math.random().toString(36).substring(2);
    function T() {}
    var b = void 0,
      x = 1,
      L = 2;
    function C(t, e, n, r) {
      try {
        t.call(e, n, r);
      } catch (t) {
        return t;
      }
    }
    function E(t, e, n) {
      var r, i, o, s;
      e.constructor === t.constructor && n === _ && e.constructor.resolve === S ? (o = t, (s = e)._state === x ? O(o, s._result) : s._state === L ? R(o, s._result) : A(s, void 0, function (t) {
        return I(o, t);
      }, function (t) {
        return R(o, t);
      })) : void 0 === n ? O(t, e) : c(n) ? (r = e, i = n, a(function (e) {
        var n = !1,
          t = C(i, r, function (t) {
            n || (n = !0, r !== t ? I(e, t) : O(e, t));
          }, function (t) {
            n || (n = !0, R(e, t));
          }, e._label);
        !n && t && (n = !0, R(e, t));
      }, t)) : O(t, e);
    }
    function I(e, t) {
      if (e === t) R(e, new TypeError("You cannot resolve a promise with itself"));else if (i = typeof (r = t), null === r || "object" !== i && "function" !== i) O(e, t);else {
        var n = void 0;
        try {
          n = t.then;
        } catch (t) {
          return void R(e, t);
        }
        E(e, t, n);
      }
      var r, i;
    }
    function k(t) {
      t._onerror && t._onerror(t._result), P(t);
    }
    function O(t, e) {
      t._state === b && (t._result = e, t._state = x, 0 !== t._subscribers.length && a(P, t));
    }
    function R(t, e) {
      t._state === b && (t._state = L, t._result = e, a(k, t));
    }
    function A(t, e, n, r) {
      var i = t._subscribers,
        o = i.length;
      t._onerror = null, i[o] = e, i[o + x] = n, i[o + L] = r, 0 === o && t._state && a(P, t);
    }
    function P(t) {
      var e = t._subscribers,
        n = t._state;
      if (0 !== e.length) {
        for (var r = void 0, i = void 0, o = t._result, s = 0; s < e.length; s += 3) r = e[s], i = e[s + n], r ? F(n, r, i, o) : i(o);
        t._subscribers.length = 0;
      }
    }
    function F(t, e, n, r) {
      var i = c(n),
        o = void 0,
        s = void 0,
        a = !0;
      if (i) {
        try {
          o = n(r);
        } catch (t) {
          a = !1, s = t;
        }
        if (e === o) return void R(e, new TypeError("A promises callback cannot return that same promise."));
      } else o = r;
      e._state !== b || (i && a ? I(e, o) : !1 === a ? R(e, s) : t === x ? O(e, o) : t === L && R(e, o));
    }
    var M = 0;
    function j(t) {
      t[w] = M++, t._state = void 0, t._result = void 0, t._subscribers = [];
    }
    var q = function () {
        function t(t, e) {
          this._instanceConstructor = t, this.promise = new t(T), this.promise[w] || j(this.promise), n(e) ? (this.length = e.length, this._remaining = e.length, this._result = new Array(this.length), 0 === this.length ? O(this.promise, this._result) : (this.length = this.length || 0, this._enumerate(e), 0 === this._remaining && O(this.promise, this._result))) : R(this.promise, new Error("Array Methods must be provided an Array"));
        }
        return t.prototype._enumerate = function (t) {
          for (var e = 0; this._state === b && e < t.length; e++) this._eachEntry(t[e], e);
        }, t.prototype._eachEntry = function (e, t) {
          var n = this._instanceConstructor,
            r = n.resolve;
          if (r === S) {
            var i = void 0,
              o = void 0,
              s = !1;
            try {
              i = e.then;
            } catch (t) {
              s = !0, o = t;
            }
            if (i === _ && e._state !== b) this._settledAt(e._state, t, e._result);else if ("function" != typeof i) this._remaining--, this._result[t] = e;else if (n === N) {
              var a = new n(T);
              s ? R(a, o) : E(a, e, i), this._willSettleAt(a, t);
            } else this._willSettleAt(new n(function (t) {
              return t(e);
            }), t);
          } else this._willSettleAt(r(e), t);
        }, t.prototype._settledAt = function (t, e, n) {
          var r = this.promise;
          r._state === b && (this._remaining--, t === L ? R(r, n) : this._result[e] = n), 0 === this._remaining && O(r, this._result);
        }, t.prototype._willSettleAt = function (t, e) {
          var n = this;
          A(t, void 0, function (t) {
            return n._settledAt(x, e, t);
          }, function (t) {
            return n._settledAt(L, e, t);
          });
        }, t;
      }(),
      N = function () {
        function e(t) {
          this[w] = M++, this._result = this._state = void 0, this._subscribers = [], T !== t && ("function" != typeof t && function () {
            throw new TypeError("You must pass a resolver function as the first argument to the promise constructor");
          }(), this instanceof e ? function (e, t) {
            try {
              t(function (t) {
                I(e, t);
              }, function (t) {
                R(e, t);
              });
            } catch (t) {
              R(e, t);
            }
          }(this, t) : function () {
            throw new TypeError("Failed to construct 'Promise': Please use the 'new' operator, this object constructor cannot be called as a function.");
          }());
        }
        return e.prototype.catch = function (t) {
          return this.then(null, t);
        }, e.prototype.finally = function (e) {
          var n = this.constructor;
          return c(e) ? this.then(function (t) {
            return n.resolve(e()).then(function () {
              return t;
            });
          }, function (t) {
            return n.resolve(e()).then(function () {
              throw t;
            });
          }) : this.then(e, e);
        }, e;
      }();
    return N.prototype.then = _, N.all = function (t) {
      return new q(this, t).promise;
    }, N.race = function (i) {
      var o = this;
      return n(i) ? new o(function (t, e) {
        for (var n = i.length, r = 0; r < n; r++) o.resolve(i[r]).then(t, e);
      }) : new o(function (t, e) {
        return e(new TypeError("You must pass an array to race."));
      });
    }, N.resolve = S, N.reject = function (t) {
      var e = new this(T);
      return R(e, t), e;
    }, N._setScheduler = function (t) {
      i = t;
    }, N._setAsap = function (t) {
      a = t;
    }, N._asap = a, N.polyfill = function () {
      var t = void 0;
      if ("undefined" != typeof global) t = global;else if ("undefined" != typeof self) t = self;else try {
        t = Function("return this")();
      } catch (t) {
        throw new Error("polyfill failed because global object is unavailable in this environment");
      }
      var e = t.Promise;
      if (e) {
        var n = null;
        try {
          n = Object.prototype.toString.call(e.resolve());
        } catch (t) {}
        if ("[object Promise]" === n && !e.cast) return;
      }
      t.Promise = N;
    }, N.Promise = N;
  }();
}, function (t, e) {
  var n = "undefined" != typeof crypto && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || "undefined" != typeof msCrypto && "function" == typeof window.msCrypto.getRandomValues && msCrypto.getRandomValues.bind(msCrypto);
  if (n) {
    var r = new Uint8Array(16);
    t.exports = function () {
      return n(r), r;
    };
  } else {
    var i = new Array(16);
    t.exports = function () {
      for (var t, e = 0; e < 16; e++) 0 == (3 & e) && (t = 4294967296 * Math.random()), i[e] = t >>> ((3 & e) << 3) & 255;
      return i;
    };
  }
}, function (t, e, n) {
  "use strict";

  n.r(e);
  var r = n(1),
    o = n.n(r),
    i = [].slice;
  for (var s = [], a = 0; a < 256; ++a) s[a] = (a + 256).toString(16).substr(1);
  function c(t) {
    if (t && t.traceId && t.id && t.parentId) {
      var e = t.sampled ? "01" : "00",
        n = t.sampled ? t.id : t.parentId;
      return "00-" + t.traceId + "-" + n + "-" + e;
    }
  }
  function l(e, t) {
    var n = !1;
    return "string" == typeof t ? n = e === t : Array.isArray(t) && t.forEach(function (t) {
      n || (n = l(e, t));
    }), n;
  }
  function u(t) {
    var e, n, r, i;
    return (e = o()(), r = n || 0, [(i = s)[e[r++]], i[e[r++]], i[e[r++]], i[e[r++]], i[e[r++]], i[e[r++]], i[e[r++]], i[e[r++]], i[e[r++]], i[e[r++]], i[e[r++]], i[e[r++]], i[e[r++]], i[e[r++]], i[e[r++]], i[e[r++]]].join("")).substr(0, t);
  }
  function d() {
    return "undefined" != typeof window && "function" == typeof Array.prototype.forEach && "function" == typeof JSON.stringify && "function" == typeof Function.bind && window.performance && "function" == typeof window.performance.now && "withCredentials" in new window.XMLHttpRequest();
  }
  function f(t, e, n) {
    if (n && t) {
      var r = w(t);
      return e && (e = String(e)), n[r] = e, n;
    }
  }
  var h = ["fetchStart", "domainLookupStart", "domainLookupEnd", "connectStart", "connectEnd", "secureConnectionStart", "requestStart", "responseStart", "responseEnd", "domLoading", "domInteractive", "domContentLoadedEventStart", "domContentLoadedEventEnd", "domComplete", "loadEventStart", "loadEventEnd"];
  function p(t) {
    return t && t.split("?")[0];
  }
  function v(t) {
    return null !== t && "object" == typeof t;
  }
  function g(t, e, n) {
    for (var r = 0, i = e.length; r < i; ++r) {
      var o = e[r];
      if (v(o) || "function" == typeof o) for (var s = Object.keys(o), a = 0, c = s.length; a < c; a++) {
        var u = s[a],
          d = o[u];
        n && v(d) ? (v(t[u]) || (t[u] = Array.isArray(d) ? [] : {}), g(t[u], [d], !1)) : t[u] = d;
      }
    }
    return t;
  }
  function m(t) {
    return g(t, i.call(arguments, 1), !1);
  }
  function y(t) {
    return g(t, i.call(arguments, 1), !0);
  }
  function _(t) {
    return void 0 === t;
  }
  function S() {}
  function w(t) {
    return t.replace(/[.*"]/g, "_");
  }
  function T() {
    var n,
      r,
      i,
      t = (n = window.performance.timing, r = n.fetchStart, i = {}, h.forEach(function (t) {
        var e = n[t];
        e && r <= e && (i[t] = e - r);
      }), i),
      e = function () {
        var t = {},
          e = window.performance;
        if (e.getEntriesByType) {
          var n = e.getEntriesByType("paint");
          if (0 < n.length) for (var r = e.timing, i = r.fetchStart - r.navigationStart, o = 0; o < n.length; o++) {
            var s = n[o],
              a = 0 <= i ? s.startTime - i : s.startTime;
            t[s.name] = a;
          }
        }
        return t;
      }(),
      o = {
        timeToFirstByte: t.responseStart,
        domInteractive: t.domInteractive,
        domComplete: t.domComplete
      };
    return e["first-contentful-paint"] && (o.firstContentfulPaint = e["first-contentful-paint"]), {
      navigationTiming: t,
      agent: o
    };
  }
  var b = {
    fetchInProgress: !1
  };
  function x(t) {
    return "__apm_symbol__" + t;
  }
  function L(t, e, n) {
    for (var r = t; r && !r.hasOwnProperty(e);) r = Object.getPrototypeOf(r);
    !r && t[e] && (r = t);
    var i,
      o,
      s,
      a,
      c = x(e);
    if (r && !(i = r[c])) {
      i = r[c] = r[e];
      var u = r && Object.getOwnPropertyDescriptor(r, e);
      if (!(a = u) || !1 !== a.writable && ("function" != typeof a.get || void 0 !== a.set)) {
        var d = n(i, c, e);
        r[e] = function () {
          return d(this, arguments);
        }, o = r[e], s = i, o[x("OriginalDelegate")] = s;
      }
    }
    return i;
  }
  var C = x("xhrIgnore"),
    E = x("xhrSync"),
    I = x("xhrURL"),
    k = x("xhrMethod"),
    O = "schedule",
    R = "invoke",
    A = "clear",
    P = "addEventListener",
    F = "removeEventListener",
    M = ["link", "css", "script", "img", "xmlhttprequest", "fetch", "beacon", "iframe"],
    j = 3e5,
    q = "page-load",
    N = "Unknown",
    H = 60,
    Q = 1024,
    D = "transaction:end",
    U = "config:change",
    B = "xmlhttprequest",
    z = "fetch",
    V = "history",
    X = "error",
    J = x("xhrTask"),
    Y = x("xhrListener"),
    $ = x("xhrScheduled");
  function Z(s) {
    var t = XMLHttpRequest.prototype,
      a = t[P],
      c = t[F];
    if (!a) {
      var e = window.XMLHttpRequestEventTarget;
      if (e) {
        var n = e.prototype;
        a = n[P], c = n[F];
      }
    }
    var u = "readystatechange";
    function d(t) {
      t.state = R, t.ignore || s(R, t);
    }
    var r = L(t, "open", function () {
        return function (t, e) {
          return t[k] = e[0], t[I] = e[1], t[E] = !1 === e[2], r.apply(t, e);
        };
      }),
      f = L(t, "send", function () {
        return function (t, e) {
          var n = {
              source: B,
              state: "",
              type: "macroTask",
              ignore: t[C],
              data: {
                target: t,
                method: t[k],
                sync: t[E],
                url: t[I],
                args: e,
                aborted: !1
              }
            },
            r = function (t) {
              XMLHttpRequest[$] = !1, t.state = O, t.ignore || s(O, t);
              var e = t.data,
                n = e.target,
                r = n[Y];
              a || (a = n[P], c = n[F]), r && c.call(n, u, r);
              var i = n[Y] = function () {
                n.readyState === n.DONE && !e.aborted && XMLHttpRequest[$] && t.state === O && d(t);
              };
              a.call(n, u, i), n[J] || (n[J] = t);
              var o = f.apply(n, e.args);
              return XMLHttpRequest[$] = !0, o;
            }(n);
          return t[E] && d(n), r;
        };
      }),
      i = L(t, "abort", function () {
        return function (t, e) {
          var n,
            r = t[J];
          if (r && "string" == typeof r.type) {
            if (r.data && r.data.aborted) return;
            (n = r).state = A, s(A, n), n.data.aborted = !0;
          }
          return i.apply(t, e);
        };
      });
  }
  var G = n(0);
  function K(a) {
    if (window.fetch && window.Request) {
      var c = window.fetch;
      window.fetch = function (t, e) {
        var i,
          n,
          o = this,
          r = arguments;
        if ("string" == typeof t) i = new Request(t, e), n = t;else {
          if (!t) return c.apply(o, r);
          n = (i = t).url;
        }
        var s = {
          source: z,
          state: "",
          type: "macroTask",
          data: {
            target: i,
            method: i.method,
            sync: !1,
            url: n,
            args: r,
            aborted: !1
          }
        };
        return new G.Promise(function (e, n) {
          var t, r;
          b.fetchInProgress = !0, (t = s).state = O, a(O, t);
          try {
            r = c.apply(o, [i]);
          } catch (t) {
            return n(t), s.data.error = t, u(s), void (b.fetchInProgress = !1);
          }
          r.then(function (t) {
            e(t), G.Promise.resolve().then(function () {
              s.data.response = t, u(s);
            });
          }, function (t) {
            n(t), G.Promise.resolve().then(function () {
              s.data.error = t, u(s);
            });
          }), b.fetchInProgress = !1;
        });
      };
    }
    function u(t) {
      t.state = R, a(R, t);
    }
  }
  var W = function () {
      function t() {
        this.observers = {};
      }
      var e = t.prototype;
      return e.observe = function (e, n) {
        var r = this;
        if ("function" == typeof n) return this.observers[e] || (this.observers[e] = []), this.observers[e].push(n), function () {
          var t = r.observers[e].indexOf(n);
          -1 < t && r.observers[e].splice(t, 1);
        };
      }, e.sendOnly = function (t, e) {
        var n = this.observers[t];
        n && n.forEach(function (t) {
          try {
            t.apply(void 0, e);
          } catch (t) {
            console.log(t, t.stack);
          }
        });
      }, e.send = function (t, e) {
        this.sendOnly(t + ":before", e), this.sendOnly(t, e), this.sendOnly(t + ":after", e);
      }, t;
    }(),
    tt = new W(),
    et = !1;
  function nt() {
    return et || (et = !0, Z(function (t, e) {
      tt.send(B, [t, e]);
    }), K(function (t, e) {
      tt.send(z, [t, e]);
    }), function (r) {
      if (window.history) {
        var i = history.pushState;
        "function" == typeof i && (history.pushState = function (t, e, n) {
          r(R, {
            source: V,
            data: {
              state: t,
              title: e,
              url: n
            }
          }), i.apply(this, arguments);
        });
      }
    }(function (t, e) {
      tt.send(V, [t, e]);
    })), tt;
  }
  var rt = !1,
    it = !1;
  var ot = [["#", "hash"], ["?", "query"], ["/", "path"], ["@", "auth", 1], [NaN, "host", void 0, 1]],
    st = /^([a-z][a-z0-9.+-]*:)?(\/\/)?([\S\s]*)/i,
    at = function () {
      function t(t) {
        var e,
          n = this.extractProtocol(t || ""),
          r = n.protocol,
          i = n.address,
          o = n.slashes,
          s = !r && !o,
          a = this.getLocation(),
          c = ot.slice();
        i = i.replace("\\", "/");
        for (var u = 0; u < c.length; u++) {
          var d = c[u],
            f = d[0],
            h = d[1];
          if ("string" == typeof f) {
            if (~(e = i.indexOf(f))) {
              var v = d[2];
              if (v) {
                var l = i.lastIndexOf(f);
                e = Math.max(e, l), this[h] = i.slice(0, e), i = i.slice(e + v);
              } else this[h] = i.slice(e), i = i.slice(0, e);
            }
          } else this[h] = i;
          this[h] = this[h] || s && d[3] && a[h] || "", d[3] && (this[h] = this[h].toLowerCase());
        }
        this.relative = s, this.protocol = r || a.protocol || "", this.origin = this.protocol && this.host && "file:" !== this.protocol ? this.protocol + "//" + this.host : "null", this.href = this.toString();
      }
      var e = t.prototype;
      return e.toString = function () {
        var t = this.protocol;
        if (t += "//", this.auth) {
          var e = "[REDACTED]",
            n = this.auth.split(":");
          t += (n[0] ? e : "") + (n[1] ? ":" + e : "") + "@";
        }
        return t += this.host, t += this.path, t += this.query, t += this.hash;
      }, e.getLocation = function () {
        var t = {};
        return "undefined" != typeof window && (t = window), t.location;
      }, e.extractProtocol = function (t) {
        var e = st.exec(t);
        return {
          protocol: e[1] ? e[1].toLowerCase() : "",
          slashes: !!e[2],
          address: e[3]
        };
      }, t;
    }(),
    ct = {
      service: {
        name: [Q, !0],
        version: !0,
        agent: {
          version: [Q, !0]
        },
        environment: !0
      }
    },
    ut = {
      "*": !0,
      headers: {
        "*": !0
      }
    },
    dt = {
      user: {
        id: !0,
        email: !0,
        username: !0
      },
      tags: {
        "*": !0
      },
      http: {
        response: ut
      },
      response: ut
    },
    ft = {
      name: [Q, !0],
      type: [Q, !0],
      id: [Q, !0],
      trace_id: [Q, !0],
      parent_id: [Q, !0],
      transaction_id: [Q, !0],
      subtype: !0,
      action: !0,
      context: dt
    },
    ht = {
      name: !0,
      parent_id: !0,
      type: [Q, !0],
      id: [Q, !0],
      trace_id: [Q, !0],
      span_count: {
        started: [Q, !0]
      },
      context: dt
    };
  function vt(t) {
    return null == t || "" === t || void 0 === t;
  }
  function lt(t, e, n) {
    var r,
      i,
      o,
      s,
      a = (r = t[e], i = n[0], o = n[1], void 0 === i && (i = Q), void 0 === o && (o = !1), void 0 === s && (s = "N/A"), o && vt(r) && (r = s), "string" == typeof r ? r.substring(0, i) : r);
    vt(a) ? delete t[e] : t[e] = a;
  }
  function pt(r, i, o) {
    void 0 === r && (r = {}), void 0 === o && (o = i);
    for (var s = Object.keys(r), a = [], t = function (t) {
        var e = s[t],
          n = !0 === r[e] ? a : r[e];
        Array.isArray(n) ? "*" === e ? Object.keys(o).forEach(function (t) {
          return lt(o, t, n);
        }) : lt(o, e, n) : pt(n, i, o[e]);
      }, e = 0; e < s.length; e++) t(e);
    return i;
  }
  var gt = function () {
      function t(t, e, n, r) {
        this._apmServer = t, this._configService = e, this._logginService = n, this._transactionService = r;
      }
      var e = t.prototype;
      return e.init = function (t) {
        var n = this;
        void 0 === t && (t = {}), this._configService.events.observe(D + ":after", function (t) {
          var e = n.createTransactionPayload(t);
          e && n._apmServer.addTransaction(e);
        }), t[V] && tt.observe(V, this.getHistorySub()), t[B] && tt.observe(B, this.getXHRSub()), t[z] && tt.observe(z, this.getFetchSub());
      }, e.getHistorySub = function () {
        var n = this._transactionService;
        return function (t, e) {
          e.source === V && t === R && n.startTransaction(e.data.title, "route-change", {
            canReuse: !0
          });
        };
      }, e.getXHRSub = function () {
        var n = this;
        return function (t, e) {
          e.source !== B || b.fetchInProgress || n.processAPICalls(t, e);
        };
      }, e.getFetchSub = function () {
        var n = this;
        return function (t, e) {
          e.source === z && n.processAPICalls(t, e);
        };
      }, e.processAPICalls = function (t, e) {
        var n = this._configService,
          r = this._transactionService,
          i = n.get("ignoreSpansForRoutes");
        if (t === O && e.data) {
          var o = new at(e.data.url);
          if (i && i.test && i.test(e.data.url)) return;
          var s = e.data.method + " " + (o.relative ? o.path : p(o.href)),
            a = r.startSpan(s, "external.http"),
            c = r.addTask();
          if (!a) return;
          var u = n.get("distributedTracing"),
            d = n.get("distributedTracingOrigins"),
            f = new at(window.location.href),
            h = l(o.origin, f.origin) || l(o.origin, d),
            v = e.data.target;
          u && h && v && this.injectDtHeader(a, v), a.addContext({
            http: {
              method: e.data.method,
              url: o.href
            }
          }), a.sync = e.data.sync, e.data.span = a, e.id = c;
        }
        t === R && e.data && e.data.span && (void 0 !== e.data.target.status ? e.data.span.addContext({
          http: {
            status_code: e.data.target.status
          }
        }) : e.data.response && e.data.span.addContext({
          http: {
            status_code: e.data.response.status
          }
        }), e.data.span.end()), t === R && e.id && r.removeTask(e.id);
      }, e.injectDtHeader = function (t, e) {
        var n,
          r = this._configService,
          i = r.get("distributedTracingHeaderName"),
          o = r.get("distributedTracingHeaderValueCallback")(t),
          s = /^[\da-f]{2}-[\da-f]{32}-[\da-f]{16}-[\da-f]{2}$/.test(n = o) && "00000000000000000000000000000000" !== n.slice(3, 35) && "0000000000000000" !== n.slice(36, 52);
        i && o && s && ("function" == typeof e.setRequestHeader ? e.setRequestHeader(i, o) : e.headers && "function" == typeof e.headers.append ? e.headers.append(i, o) : e[i] = o);
      }, e.extractDtHeader = function (t) {
        var e = this._configService.get("distributedTracingHeaderName");
        if (t) return function (t) {
          var e = /^([\da-f]{2})-([\da-f]{32})-([\da-f]{16})-([\da-f]{2})$/.exec(t);
          if (e) {
            var n = "00" !== e[4];
            return {
              traceId: e[2],
              id: e[3],
              sampled: n
            };
          }
        }(t[e]);
      }, e.setTransactionContext = function (t) {
        var e = this._configService.get("context");
        e && t.addContext(e);
      }, e.filterTransaction = function (t) {
        var e = this._configService.get("transactionDurationThreshold"),
          n = t.duration();
        if (!n) return !1;
        if (e < n) return !1;
        if (0 === t.spans.length) return !1;
        t.sampled || t.resetSpans();
        var r = this._configService.get("browserResponsivenessInterval");
        if (this._configService.get("checkBrowserResponsiveness") && !t.isHardNavigation) {
          var i = this._configService.get("browserResponsivenessBuffer");
          if (!this.checkBrowserResponsiveness(t, r, i)) return !1;
        }
        return !0;
      }, e.adjustTransactionTime = function (t) {
        var e = t.spans,
          n = function (t) {
            for (var e = t[0], n = 1; n < t.length; n++) {
              var r = t[n];
              e._start > r._start && (e = r);
            }
            return e;
          }(e);
        n && n._start < t._start && (t._start = n._start);
        var r = function (t) {
          for (var e = null, n = 0; n < t.length; n++) {
            var r = t[n];
            -1 === String(r.type).indexOf("external") && (!e || e._end < r._end) && (e = r);
          }
          return e;
        }(e);
        r && r._end > t._end && (t._end = r._end);
        for (var i = t._end, o = 0; o < e.length; o++) {
          var s = e[o];
          s._end > i && (s._end = i, s.type += ".truncated"), s._start > i && (s._start = i);
        }
      }, e.prepareTransaction = function (e) {
        if (e.spans.sort(function (t, e) {
          return t._start - e._start;
        }), this._configService.get("groupSimilarSpans")) {
          var t = this._configService.get("similarSpanThreshold");
          e.spans = this.groupSmallContinuouslySimilarSpans(e, t);
        }
        e.spans = e.spans.filter(function (t) {
          return 0 < t.duration() && t._start >= e._start && t._end <= e._end;
        }), this.setTransactionContext(e);
      }, e.createTransactionDataModel = function (n) {
        var t = this._configService.get("context"),
          r = n._start,
          e = n.spans.map(function (t) {
            var e = {
              id: t.id,
              transaction_id: n.id,
              parent_id: t.parentId || n.id,
              trace_id: n.traceId,
              name: t.name,
              type: t.type,
              subType: t.subType,
              action: t.action,
              sync: t.sync,
              start: t._start - r,
              duration: t.duration(),
              context: t.context
            };
            return pt(ft, e);
          }),
          i = y({}, t, n.context),
          o = {
            id: n.id,
            trace_id: n.traceId,
            name: n.name,
            type: n.type,
            duration: n.duration(),
            spans: e,
            context: i,
            marks: n.marks,
            span_count: {
              started: e.length
            },
            sampled: n.sampled
          };
        return pt(ht, o);
      }, e.createTransactionPayload = function (t) {
        if (this.adjustTransactionTime(t), this.prepareTransaction(t), this.filterTransaction(t)) return this.createTransactionDataModel(t);
      }, e.convertTransactionsToServerModel = function (t) {
        var e = this;
        return t.map(function (t) {
          return e.createTransactionDataModel(t);
        });
      }, e.groupSmallContinuouslySimilarSpans = function (o, s) {
        var a = o.duration(),
          c = [],
          u = 1;
        return o.spans.forEach(function (t, e) {
          if (0 === c.length) c.push(t);else {
            var n = c[c.length - 1],
              r = n.type === t.type && n.subType === t.subType && n.action === t.action && n.name === t.name && t.duration() / a < s && (t._start - n._end) / a < s,
              i = o.spans.length === e + 1;
            r && (u++, n._end = t._end), 1 < u && (!r || i) && (n.name = u + "x " + n.name, u = 1), r || c.push(t);
          }
        }), c;
      }, e.checkBrowserResponsiveness = function (t, e, n) {
        var r = t.browserResponsivenessCounter;
        if (void 0 === e || void 0 === r) return !0;
        var i = t.duration();
        return Math.floor(i / e) <= r + n;
      }, t;
    }(),
    mt = function () {
      function t(t, e, n) {
        void 0 === n && (n = {}), t || (t = N), e || (e = "custom"), this.options = n, this.name = t, this.type = e, this.id = this.options.id || u(16), this.traceId = this.options.traceId, this.sampled = this.options.sampled, this.timestamp = this.options.timestamp || Date.now(), this.ended = !1, this._start = window.performance.now(), this._end = void 0, this.onEnd = this.options.onEnd;
      }
      var e = t.prototype;
      return e.ensureContext = function () {
        this.context || (this.context = {});
      }, e.addTags = function (t) {
        console.warn("addTags deprecated, please use addLabels"), this.addLabels(t);
      }, e.addLabels = function (e) {
        this.ensureContext();
        var n = this.context;
        n.tags || (n.tags = {}), Object.keys(e).forEach(function (t) {
          return f(t, e[t], n.tags);
        });
      }, e.addContext = function (t) {
        t && (this.ensureContext(), y(this.context, t));
      }, e.end = function () {
        this.ended || (this.ended = !0, this._end = window.performance.now(), this.callOnEnd());
      }, e.callOnEnd = function () {
        "function" == typeof this.onEnd && this.onEnd(this);
      }, e.duration = function () {
        if (_(this._end) || _(this._start)) return null;
        var t = this._end - this._start;
        return parseFloat(t);
      }, t;
    }();
  var yt = function (o) {
    var t, e;
    function n(t, e, n) {
      var r;
      if ((r = o.call(this, t, e, n) || this).parentId = r.options.parentId, r.subType = void 0, r.action = void 0, -1 !== r.type.indexOf(".")) {
        var i = r.type.split(".", 3);
        r.type = i[0], r.subType = i[1], r.action = i[2];
      }
      return r.sync = r.options.sync, r;
    }
    return e = o, (t = n).prototype = Object.create(e.prototype), (t.prototype.constructor = t).__proto__ = e, n;
  }(mt);
  var _t = function (i) {
      var t, e;
      function n(t, e, n) {
        var r;
        return (r = i.call(this, t, e, n) || this).traceId = u(), r.marks = void 0, r.spans = [], r._activeSpans = {}, r.nextAutoTaskId = 1, r._scheduledTasks = [], r.isHardNavigation = !1, r.sampled = Math.random() <= r.options.transactionSampleRate, r;
      }
      e = i, (t = n).prototype = Object.create(e.prototype), (t.prototype.constructor = t).__proto__ = e;
      var r = n.prototype;
      return r.addMarks = function (t) {
        this.marks = y(this.marks || {}, t);
      }, r.mark = function (t) {
        var e = w(t),
          n = window.performance.now() - this._start,
          r = {};
        r[e] = n, this.addMarks({
          custom: r
        });
      }, r.canReuse = function (t) {
        return void 0 === t && (t = 5e3), !!this.options.canReuse && !this.ended && performance.now() - this._start < t;
      }, r.redefine = function (t, e, n) {
        t && (this.name = t), e && (this.type = e), n && (this.options = m(this.options, n));
      }, r.startSpan = function (t, e, n) {
        var r = this;
        if (!this.ended) {
          var i = m({}, n);
          i.onEnd = function (t) {
            r._onSpanEnd(t);
          }, i.traceId = this.traceId, i.sampled = this.sampled, i.parentId || (i.parentId = this.id);
          var o = new yt(t, e, i);
          return this._activeSpans[o.id] = o;
        }
      }, r.isFinished = function () {
        return 0 === this._scheduledTasks.length;
      }, r.detectFinish = function () {
        this.isFinished() && this.end();
      }, r.end = function () {
        if (!this.ended) {
          for (var t in this.ended = !0, this._end = window.performance.now(), this._activeSpans) {
            var e = this._activeSpans[t];
            e.type = e.type + ".truncated", e.end();
          }
          var n = {
            page: {
              referer: document.referrer,
              url: window.location.href
            }
          };
          this.addContext(n), this.callOnEnd();
        }
      }, r.addTask = function (t) {
        if (void 0 === t && (t = "task" + this.nextAutoTaskId++), -1 == this._scheduledTasks.indexOf(t)) return this._scheduledTasks.push(t), t;
      }, r.removeTask = function (t) {
        var e = this._scheduledTasks.indexOf(t);
        -1 < e && this._scheduledTasks.splice(e, 1), this.detectFinish();
      }, r.resetSpans = function () {
        this.spans = [];
      }, r._onSpanEnd = function (t) {
        this.spans.push(t), delete this._activeSpans[t.id];
      }, n;
    }(mt),
    St = [["domainLookupStart", "domainLookupEnd", "Domain lookup"], ["connectStart", "connectEnd", "Making a connection to the server"], ["requestStart", "responseEnd", "Requesting and receiving the document"], ["domLoading", "domInteractive", "Parsing the document, executing sync. scripts"], ["domContentLoadedEventStart", "domContentLoadedEventEnd", 'Fire "DOMContentLoaded" event'], ["loadEventStart", "loadEventEnd", 'Fire "load" event']];
  function wt(t, e, n, r) {
    return "number" == typeof t && "number" == typeof e && n <= t && t < e && e - n <= r && e - t < j && t - n < j && e - n < j;
  }
  function Tt(t) {
    var e = {
        transfer_size: t.transferSize,
        encoded_body_size: t.encodedBodySize,
        decoded_body_size: t.decodedBodySize
      },
      n = function (t) {
        void 0 === t && (t = []);
        for (var e = [], n = 0; n < t.length; n++) {
          var r = t[n],
            i = r.name,
            o = r.duration,
            s = r.description,
            a = i;
          s && (a += ";desc=" + s), o && (a += ";dur=" + o), e.push(a);
        }
        return e.join(", ");
      }(t.serverTiming);
    return n && (e.headers = {
      "server-timing": n
    }), e;
  }
  function bt(t) {
    var e = t.name,
      n = t.initiatorType,
      r = t.startTime,
      i = t.responseEnd,
      o = "resource";
    n && (o += "." + n);
    var s = p(e),
      a = new yt(s, o);
    return a.addContext({
      http: {
        url: e,
        response: Tt(t)
      }
    }), a._start = r, a.end(), a._end = i, a;
  }
  function xt(e) {
    var t = window.performance;
    if (e.isHardNavigation && t && t.timing) {
      var n = t.timing;
      if (e.marks && e.marks.custom) {
        var r = e.marks.custom;
        Object.keys(r).forEach(function (t) {
          r[t] += e._start;
        });
      }
      e._start = 0;
      var i = e._end;
      if (function (t, e, n) {
        for (var r = [], i = 0; i < St.length; i++) {
          var o = t[St[i][0]],
            s = t[St[i][1]];
          if (wt(o, s, e, n)) {
            var a = new yt(St[i][2], "hard-navigation.browser-timing");
            "requestStart" === St[i][0] && (a.pageResponse = !0), a._start = o - e, a.ended = !0, a._end = s - e, r.push(a);
          }
        }
        return r;
      }(n, n.fetchStart, i).forEach(function (t) {
        t.traceId = e.traceId, t.sampled = e.sampled, t.pageResponse && e.options.pageLoadSpanId && (t.id = e.options.pageLoadSpanId), e.spans.push(t);
      }), "function" == typeof t.getEntriesByType) {
        for (var o = t.getEntriesByType("resource"), s = [], a = 0; a < e.spans; a++) {
          var c = e.spans[a];
          "external" === c.type && "http" === c.subType || s.push(c.name.split(" ")[1]);
        }
        (function (t, e, n) {
          for (var r = [], i = 0; i < t.length; i++) {
            var o = t[i],
              s = o.initiatorType,
              a = o.name,
              c = o.startTime,
              u = o.responseEnd;
            if ("xmlhttprequest" !== s && "fetch" !== s && a) if (-1 !== M.indexOf(s)) {
              if (!wt(c, u, 0, n)) continue;
              r.push(bt(t[i]));
            } else {
              if (null != s) continue;
              for (var d = !1, f = 0; f < e.length; f++) {
                var h = a.lastIndexOf(e[f]);
                if (-1 < h && h === a.length - e[f].length) {
                  d = !0;
                  break;
                }
              }
              !d && wt(c, u, 0, n) && r.push(bt(t[i]));
            }
          }
          return r;
        })(o, s, i).forEach(function (t) {
          return e.spans.push(t);
        }), function (t, e) {
          for (var n = [], r = 0; r < t.length; r++) {
            var i = t[r],
              o = i.name,
              s = i.startTime,
              a = i.duration,
              c = s + a;
            if (!(a <= H) && wt(s, c, 0, e)) {
              var u = new yt(o, "app");
              u._start = s, u.end(), u._end = c, n.push(u);
            }
          }
          return n;
        }(t.getEntriesByType("measure"), i).forEach(function (t) {
          return e.spans.push(t);
        });
        var u = t.getEntriesByType("navigation");
        u && 0 < u.length && (u = u[0], e.addContext({
          response: Tt(u)
        }));
      }
    }
  }
  var Lt = function () {
      function t(t, e) {
        this._config = e, this._logger = t, this.currentTransaction = void 0, this._alreadyCapturedPageLoad = !1;
      }
      var e = t.prototype;
      return e.ensureCurrentTransaction = function (t) {
        t || (t = this.createPerfOptions());
        var e = this.getCurrentTransaction();
        return e || (t.canReuse = !0, this.createTransaction(void 0, void 0, t));
      }, e.getCurrentTransaction = function () {
        if (this.currentTransaction && !this.currentTransaction.ended) return this.currentTransaction;
      }, e.setCurrentTransaction = function (t) {
        this.currentTransaction = t;
      }, e.createTransaction = function (t, e, n) {
        var r = new _t(t, e, n);
        return this.setCurrentTransaction(r), n.checkBrowserResponsiveness && this.startCounter(r), r;
      }, e.startCounter = function (t) {
        t.browserResponsivenessCounter = 0;
        var e = this._config.get("browserResponsivenessInterval");
        if (void 0 !== e) var n = setInterval(function () {
          t.ended ? window.clearInterval(n) : t.browserResponsivenessCounter++;
        }, e);
      }, e.capturePageLoadMetrics = function (t) {
        if (this._config.get("capturePageLoad") && !this._alreadyCapturedPageLoad && t.isHardNavigation) return xt(t), t.addMarks(T()), self._alreadyCapturedPageLoad = !0;
      }, e.createPerfOptions = function (t) {
        var e = this._config.config;
        return m({
          pageLoadTraceId: e.pageLoadTraceId,
          pageLoadSampled: e.pageLoadSampled,
          pageLoadSpanId: e.pageLoadSpanId,
          pageLoadTransactionName: e.pageLoadTransactionName,
          transactionSampleRate: e.transactionSampleRate,
          checkBrowserResponsiveness: e.checkBrowserResponsiveness
        }, t);
      }, e.startTransaction = function (t, e, n) {
        var r = this,
          i = this.createPerfOptions(n),
          o = this.getCurrentTransaction();
        return o ? o.canReuse() && i.canReuse ? o.redefine(t, void 0, i) : (o.end(), o = this.createTransaction(t, e, i)) : o = this.createTransaction(t, e, i), e === q && (o.isHardNavigation = !0, i.pageLoadTraceId && (o.traceId = i.pageLoadTraceId), i.pageLoadSampled && (o.sampled = i.pageLoadSampled), o.name === N && i.pageLoadTransactionName && (o.name = i.pageLoadTransactionName)), this._config.events.send("transaction:start", [o]), o.onEnd = function () {
          return G.Promise.resolve().then(function () {
            r.shouldIgnoreTransaction(o.name) || o.type === q || r.add(o);
          }, function (t) {
            0;
          });
        }, o;
      }, e.shouldIgnoreTransaction = function (t) {
        var e = this._config.get("ignoreTransactions");
        if (e && e.length) for (var n = 0; n < e.length; n++) {
          var r = e[n];
          if ("function" == typeof r.test) {
            if (r.test(t)) return !0;
          } else if (r === t) return !0;
        }
        return !1;
      }, e.startSpan = function (t, e, n) {
        var r = this.ensureCurrentTransaction();
        if (r) return r.startSpan(t, e, n);
      }, e.add = function (t) {
        this._config.events.send(D, [t]);
      }, e.addTask = function (t) {
        var e = this.ensureCurrentTransaction();
        if (e) {
          t = e.addTask(t);
          0;
        }
        return t;
      }, e.removeTask = function (t) {
        var e = this.getCurrentTransaction();
        e && e.removeTask(t);
      }, e.detectFinish = function () {
        var t = this.getCurrentTransaction();
        t && t.detectFinish();
      }, t;
    }(),
    Ct = function (i) {
      i.registerServiceCreator("TransactionService", function () {
        var t = i.getService("ConfigService"),
          e = i.getService("LoggingService");
        return new Lt(e, t);
      }), i.registerServiceCreator("PerformanceMonitoring", function () {
        var t = i.getService("ConfigService"),
          e = i.getService("LoggingService"),
          n = i.getService("ApmServer"),
          r = i.getService("TransactionService");
        return new gt(n, t, e, r);
      });
    },
    Et = function () {
      function t(t, e, n) {
        e || (e = {}), this.onFlush = t, this.routeDurationThreshold = e.routeDurationThreshold || 500, this.queueLimit = e.queueLimit || -1, this.slowestTxnsQueueLimit = e.slowestTxnsQueueLimit || 10, this.flushInterval = e.flushInterval || 0, this.timeoutId = void 0, this.transactions = {}, this.slowestTxns = [], this.totalTrans = 0, this.urlMaxLength = n.get("urlMaxLength");
      }
      var e = t.prototype;
      return e._setTimer = function () {
        var t = this;
        this.timeoutId = setTimeout(function () {
          t.flush();
        }, this.flushInterval);
      }, e.flush = function () {
        var t = Object.keys(this.transactions).map(function (t) {
            var r = this.transactions[t],
              e = {
                n: t,
                d: [r.duration.count, r.duration.total, r.duration.min, r.duration.max]
              };
            return e.spans = Object.keys(r.spans).map(function (t) {
              var e = r.spans[t],
                n = {};
              return n.n = t, n.t = e.type, n.d = [e.duration.count, e.duration.total, e.duration.min, e.duration.max], e.url && e.method && (n.u = e.url, n.m = e.method), n;
            }), e;
          }, this),
          n = [];
        this.slowestTxns.forEach(function (t) {
          var e = t.context && t.context.page && t.context.page.url;
          if (e) {
            var r = {
              r: t.txnName || "",
              n: e.slice(0, this.urlMaxLength),
              d: t.duration || 0,
              spans: []
            };
            t.spans = t.spans || [], t.spans.forEach(function (t) {
              var e = {
                n: t.name,
                d: t.duration,
                s: t.start,
                t: t.type
              };
              if ("external" === t.type) {
                var n = t.context && t.context.http || {};
                if (window.atatus && window.atatus._isAllowedUrl && !window.atatus._isAllowedUrl(n.url || "")) return;
                e.m = n.method, e.st = n.status_code, e.u = n.url.slice(0, this.urlMaxLength), e.t = "ajax";
              }
              r.spans.push(e);
            }.bind(this)), n.push(r);
          }
        }.bind(this));
        var e = {
          data: t,
          slowestRoutes: n
        };
        this.onFlush(e), this._clear();
      }, e._clear = function () {
        void 0 !== this.timeoutId && (clearTimeout(this.timeoutId), this.timeoutId = void 0), this.transactions = {}, this.slowestTxns = [], this.totalTrans = 0;
      }, e.addSlowestTxn = function (t) {
        var e = this.slowestTxns.length;
        if (e < this.slowestTxnsQueueLimit) this.slowestTxns.push(t);else {
          var n = Math.floor(Math.random() * (e + 2));
          n < this.slowestTxnsQueueLimit && (this.slowestTxns[n] = t);
        }
      }, e.add = function (t) {
        var e = t.context && t.context.page && t.context.page.url,
          n = "";
        try {
          window.atatus && window.atatus.getTransformRouteUrlFn() && (n = window.atatus.getTransformRouteUrlFn()(e));
        } catch (t) {}
        if (n || (n = e.split("?")[0]), n && (t.txnName = n, t.duration = t.duration || 0, t.spans = t.spans || [], t.spans.length || !(4e3 < t.duration))) {
          var i = this.transactions[n] || {
            duration: {
              total: 0,
              min: t.duration,
              max: t.duration,
              count: 0
            },
            spans: {}
          };
          (this.transactions[n] = i).duration.total += t.duration, i.duration.max = t.duration >= i.duration.max ? t.duration : i.duration.max, i.duration.min = t.duration < i.duration.min ? t.duration : i.duration.min, i.duration.count++, this.totalTrans++, t.spans.forEach(function (t) {
            var e = t.name;
            if (e) {
              var n = t.context && t.context.http && t.context.http.url || "";
              if (!window.atatus || !window.atatus._isAllowedUrl || window.atatus._isAllowedUrl(n)) {
                t.duration = t.duration || 0;
                var r = i.spans[e] || {
                  duration: {
                    total: 0,
                    min: t.duration,
                    max: t.duration,
                    count: 0
                  }
                };
                "external" === t.type ? (r.method = t.context && t.context.http && t.context.http.method, r.url = n.split("?")[0], r.type = "ajax") : r.type = t.type || "", r.duration.total += t.duration, r.duration.max = t.duration >= r.duration.max ? t.duration : r.duration.max, r.duration.min = t.duration < r.duration.min ? t.duration : r.duration.min, r.duration.count++, i.spans[e] = r;
              }
            }
          }, this), t.duration >= this.routeDurationThreshold && this.addSlowestTxn(t), -1 !== this.queueLimit && this.totalTrans >= this.queueLimit ? this.flush() : void 0 === this.timeoutId && this._setTimer();
        }
      }, t;
    }(),
    It = function () {
      function t(t, e) {
        e || (e = {}), this.onFlush = t, this.items = [], this.queueLimit = e.queueLimit || -1, this.flushInterval = e.flushInterval || 0, this.timeoutId = void 0;
      }
      var e = t.prototype;
      return e._setTimer = function () {
        var t = this;
        this.timeoutId = setTimeout(function () {
          t.flush();
        }, this.flushInterval);
      }, e.flush = function () {
        this.onFlush(this.items), this._clear();
      }, e._clear = function () {
        void 0 !== this.timeoutId && (clearTimeout(this.timeoutId), this.timeoutId = void 0), this.items = [];
      }, e.add = function (t) {
        this.items.push(t), -1 !== this.queueLimit && this.items.length >= this.queueLimit ? this.flush() : void 0 === this.timeoutId && this._setTimer();
      }, t;
    }();
  var kt = function (e, n, t) {
      var r,
        i = t.context || this,
        o = t.limit,
        s = t.interval,
        a = t.countFn || function () {},
        c = 0;
      return function () {
        var t = "function" == typeof a && a.apply(i, arguments);
        return "number" != typeof t && (t = 1), c += t, void 0 === r && (r = setTimeout(function () {
          r = void (c = 0);
        }, s)), o < c ? "function" == typeof n ? n.apply(i, arguments) : void 0 : e.apply(i, arguments);
      };
    },
    Ot = function () {
      function t() {}
      return t.stringify = function (t) {
        return JSON.stringify(t) + "\n";
      }, t;
    }(),
    Rt = function () {
      function t(t, e) {
        this._configService = t, this._loggingService = e, this.errorQueue = void 0, this.transactionQueue = void 0, this.throttleAddError = void 0, this.throttleAddTransaction = void 0, this.initialized = !1, this.ndjsonSpan = {};
      }
      var e = t.prototype;
      return e.init = function () {
        this.initialized || (this.initialized = !0, this.initErrorQueue(), this.initTransactionQueue());
      }, e.createMetaData = function () {
        var t = this._configService,
          e = {
            service: {
              name: t.get("serviceName"),
              version: t.get("serviceVersion"),
              agent: {
                name: "js-base",
                version: t.version
              },
              language: {
                name: "javascript"
              },
              environment: t.get("environment")
            }
          };
        return pt(ct, e);
      }, e._postJson = function (t, e) {
        return this._makeHttpRequest("POST", t, e, {
          "Content-Type": "application/x-ndjson"
        });
      }, e._constructError = function (t) {
        var e = t.url,
          n = t.status,
          r = (t.responseText, e + " HTTP status: " + n);
        return new Error(r);
      }, e._makeHttpRequest = function (e, o, s, a) {
        return new G.Promise(function (n, r) {
          var i = new window.XMLHttpRequest();
          if (i[C] = !0, i.open(e, o, !0), i.timeout = 1e4, a) for (var t in a) a.hasOwnProperty(t) && i.setRequestHeader(t, a[t]);
          i.onreadystatechange = function () {
            if (4 === i.readyState) {
              var t = i.status,
                e = i.responseText;
              0 === t || 399 < t && t < 600 ? r({
                url: o,
                status: t,
                responseText: e
              }) : n(e);
            }
          }, i.onerror = function () {
            var t = i.status,
              e = i.responseText;
            r({
              url: o,
              status: t,
              responseText: e
            });
          }, i.send(s);
        });
      }, e._createQueue = function (t) {
        var e = this._configService.get("queueLimit"),
          n = this._configService.get("flushInterval");
        return new It(t, {
          queueLimit: e,
          flushInterval: n
        });
      }, e._createTransactionQueue = function (t) {
        var e = this._configService.get("queueLimit"),
          n = this._configService.get("flushInterval");
        return new Et(t, {
          queueLimit: e,
          flushInterval: n
        }, this._configService);
      }, e.initErrorQueue = function () {
        var n = this;
        this.errorQueue && this.errorQueue.flush(), this.errorQueue = this._createQueue(function (t) {
          var e = n.sendErrors(t);
          e && e.catch(function (t) {
            n._loggingService.warn("Failed sending errors!", n._constructError(t));
          });
        });
        var t = this._configService.get("errorThrottleLimit"),
          e = this._configService.get("errorThrottleInterval");
        this.throttleAddError = kt(this.errorQueue.add.bind(this.errorQueue), function () {
          return n._loggingService.warn("Dropped error due to throttling!");
        }, {
          limit: t,
          interval: e
        });
      }, e.initTransactionQueue = function () {
        var n = this;
        this.transactionQueue && this.transactionQueue.flush(), this.transactionQueue = this._createTransactionQueue(function (t) {
          var e = n.sendTransactions(t);
          e && e.catch(function (t) {
            n._loggingService.warn("Failed sending transactions!", n._constructError(t));
          });
        });
        var t = this._configService.get("transactionThrottleLimit"),
          e = this._configService.get("transactionThrottleInterval");
        this.throttleAddTransaction = kt(this.transactionQueue.add.bind(this.transactionQueue), function () {
          return n._loggingService.warn("Dropped transaction due to throttling!");
        }, {
          limit: t,
          interval: e
        });
      }, e.addError = function (t) {
        this.errorQueue || this.initErrorQueue(), this.throttleAddError(t);
      }, e.addTransaction = function (t) {
        this.transactionQueue || this.initTransactionQueue(), this.throttleAddTransaction(t);
      }, e.ndjsonErrors = function (t) {
        return t.map(function (t) {
          return Ot.stringify({
            error: t
          });
        });
      }, e.ndjsonTransactions = function (t) {
        var n = this.ndjsonSpan;
        return t.map(function (t) {
          var e = "";
          return t.spans && (e = t.spans.map(function (t) {
            return n.span = t, Ot.stringify(n);
          }).join(""), delete t.spans), Ot.stringify({
            transaction: t
          }) + e;
        });
      }, e._send = function (t, e) {
        if (void 0 === t && (t = []), void 0 === e && (e = "transaction"), 0 !== t.length) {
          var n = {
              service: this.createMetaData().service,
              data: t
            },
            r = this._configService.applyFilters(n);
          if (r) {
            var i,
              o = this._configService.getEndpointUrl();
            if ("errors" === e) i = this.ndjsonErrors(r.data);else {
              if ("transaction" !== e) return void 0;
              i = this.ndjsonTransactions(r.data);
            }
            i.unshift(Ot.stringify({
              metadata: {
                service: r.service
              }
            }));
            var s = i.join("");
            return this._postJson(o, s);
          }
          this._loggingService.warn("Dropped payload due to filtering!");
        }
      }, e.sendTransactions = function (t) {
        window.atatus.sendSPAPerf(t);
      }, e.sendErrors = function (t) {}, t;
    }();
  var At = function () {
      function t() {
        this.config = {}, this.defaults = {
          serviceName: "",
          serviceVersion: "",
          environment: "",
          serverUrl: "https://br-rx.atatus.com",
          serverUrlPrefix: "/browser/track",
          active: !0,
          instrument: !0,
          disableInstrumentations: [X, q],
          debug: !1,
          logLevel: "warn",
          browserResponsivenessInterval: 500,
          browserResponsivenessBuffer: 3,
          checkBrowserResponsiveness: !0,
          groupSimilarSpans: !0,
          similarSpanThreshold: .05,
          capturePageLoad: !0,
          ignoreTransactions: [],
          errorThrottleLimit: 20,
          errorThrottleInterval: 3e4,
          transactionThrottleLimit: 20,
          transactionThrottleInterval: 3e4,
          transactionDurationThreshold: 6e4,
          queueLimit: -1,
          flushInterval: 3e4,
          sendPageLoadTransaction: !0,
          distributedTracing: !0,
          distributedTracingOrigins: [],
          distributedTracingHeaderValueCallback: c,
          distributedTracingHeaderName: "atatus-apm-traceparent",
          pageLoadTraceId: "",
          pageLoadSpanId: "",
          pageLoadSampled: !1,
          pageLoadTransactionName: "",
          transactionSampleRate: 1,
          context: {},
          urlMaxLength: 250,
          ignoreSpansForRoutes: null
        }, this.events = new W(), this.filters = [], this.version = "";
      }
      var e = t.prototype;
      return e.init = function () {
        this.setConfig({});
      }, e.isActive = function () {
        return this.get("active");
      }, e.setVersion = function (t) {
        this.version = t;
      }, e.setIgnoreSpansForRoutes = function (t) {
        this.config.ignoreSpansForRoutes = t;
      }, e.addFilter = function (t) {
        if ("function" != typeof t) throw new Error("Argument to must be function");
        this.filters.push(t);
      }, e.applyFilters = function (t) {
        for (var e = 0; e < this.filters.length; e++) if (!(t = this.filters[e](t))) return;
        return t;
      }, e.get = function (t) {
        return t.split(".").reduce(function (t, e) {
          return t && t[e];
        }, this.config);
      }, e.getEndpointUrl = function () {
        return this.config.serverUrl + this.config.serverUrlPrefix;
      }, e.set = function (t, e) {
        for (var n = t.split("."), r = n.length - 1, i = this.config, o = 0; o < r + 1; o++) {
          var s = n[o];
          if (s) if (o === r) i[s] = e;else {
            var a = i[s] || {};
            i[s] = a, i = a;
          }
        }
      }, e.setUserContext = function (t) {
        void 0 === t && (t = {});
        var e = {},
          n = t,
          r = n.id,
          i = n.username,
          o = n.email;
        "number" != typeof r && "string" != typeof r || (e.id = r), "string" == typeof i && (e.username = i), "string" == typeof o && (e.email = o), this.set("context.user", e);
      }, e.setCustomContext = function (t) {
        t && "object" == typeof t && this.set("context.custom", t);
      }, e.addLabels = function (e) {
        var n = this;
        this.config.context.tags || (this.config.context.tags = {}), Object.keys(e).forEach(function (t) {
          return f(t, e[t], n.config.context.tags);
        });
      }, e.setConfig = function (t) {
        void 0 === t && (t = {}), this.config = y({}, this.defaults, this.config, t), this.config.urlMaxLength = this.config.urlMaxLength || 250, this.events.send(U, [this.config]);
      }, e.validate = function (e) {
        void 0 === e && (e = {});
        var n = ["serviceName", "serverUrl"],
          r = {
            missing: [],
            invalid: []
          };
        return Object.keys(e).forEach(function (t) {
          -1 === n.indexOf(t) || e[t] || r.missing.push(t);
        }), e.serviceName && !/^[a-zA-Z0-9 _-]+$/.test(e.serviceName) && r.invalid.push({
          key: "serviceName",
          value: e.serviceName,
          allowed: "a-z, A-Z, 0-9, _, -, <space>"
        }), r;
      }, t;
    }(),
    Pt = function () {
      function t(t) {
        t || (t = {}), this.levels = ["trace", "debug", "info", "warn", "error"], this.level = t.level || "info", this.prefix = t.prefix || "", this.resetLogMethods();
      }
      var e = t.prototype;
      return e.shouldLog = function (t) {
        return this.levels.indexOf(t) >= this.levels.indexOf(this.level);
      }, e.setLevel = function (t) {
        this.level = t, this.resetLogMethods();
      }, e.resetLogMethods = function () {
        var o = this;
        this.levels.forEach(function (i) {
          o[i] = o.shouldLog(i) ? function () {
            var t,
              e = o.prefix;
            switch (i) {
              case "trace":
              case "debug":
                t = "info";
                break;
              default:
                t = i;
            }
            var n = arguments;
            e && ("function" == typeof e && (e = e(i)), n[0] = e + n[0]);
            if (console) {
              var r = console[t] ? console[t] : console.log;
              "function" == typeof r && r.apply(console, n);
            }
          } : S;
        });
      }, t;
    }(),
    Ft = function () {
      function t() {
        this._serviceCreators = {}, this._serviceInstances = {}, this.initialized = !1;
      }
      var e = t.prototype;
      return e.registerCoreServices = function () {
        var t = this;
        this.registerServiceCreator("ConfigService", function () {
          return new At();
        }), this.registerServiceCreator("LoggingService", function () {
          return new Pt();
        }), this.registerServiceCreator("ApmServer", function () {
          return new Rt(t.getService("ConfigService"), t.getService("LoggingService"));
        });
      }, e.init = function () {
        if (!this.initialized) {
          this.initialized = !0;
          var t = this.getService("ConfigService");
          t.init();
          var e = this.getService("LoggingService");
          n(e, t), t.events.observe(U, function () {
            n(e, t);
          }), this.getService("ApmServer").init();
        }
        function n(t, e) {
          var n = e.get("debug"),
            r = e.get("logLevel");
          !0 === n && "trace" !== r ? t.setLevel("debug") : t.setLevel(r);
        }
      }, e.registerServiceCreator = function (t, e) {
        this._serviceCreators[t] = e;
      }, e.registerServiceInstance = function (t, e) {
        this._serviceInstances[t] = e;
      }, e.getService = function (t) {
        if (!this._serviceInstances[t]) {
          if ("function" != typeof this._serviceCreators[t]) throw new Error("Can not get service, No creator for: " + t);
          this._serviceInstances[t] = this._serviceCreators[t](this);
        }
        return this._serviceInstances[t];
      }, t;
    }();
  var Mt = function () {
    function t(t, e) {
      this._disable = e, this.serviceFactory = t, this._initialized = !1;
    }
    var e = t.prototype;
    return e.init = function (t) {
      if (this.isEnabled() && !this._initialized) {
        this._initialized = !0;
        var e = this.serviceFactory.getService("ConfigService");
        e.setVersion("4.0.2"), this.config(t);
        var n = this.serviceFactory.getService("LoggingService");
        if (!e.isActive()) return n.info("Atatus agent is inactive"), this;
        this.serviceFactory.init();
        var r = (i = e.get("instrument"), o = e.get("disableInstrumentations"), (s = {})[B] = !1, s[z] = !1, s[V] = !1, s[q] = !1, s[X] = !1, a = s, i && Object.keys(a).forEach(function (t) {
          -1 === o.indexOf(t) && (a[t] = !0);
        }), a);
        if (this.serviceFactory.getService("PerformanceMonitoring").init(r), r[X]) this.serviceFactory.getService("ErrorLogging").registerGlobalEventListener();
        r[q] && e.get("sendPageLoadTransaction") && this._sendPageLoadMetrics();
      }
      var i, o, s, a;
      return this;
    }, e._sendPageLoadMetrics = function () {
      var t = this.serviceFactory.getService("TransactionService").startTransaction(void 0, q, {
        canReuse: !0
      });
      t && t.addTask(q);
      var e = function () {
        setTimeout(function () {
          t && t.removeTask(q);
        });
      };
      "complete" === document.readyState ? e() : window.addEventListener("load", e);
    }, e.isEnabled = function () {
      return !this._disable;
    }, e.observe = function (t, e) {
      this.serviceFactory.getService("ConfigService").events.observe(t, e);
    }, e.config = function (t) {
      var e = this.serviceFactory.getService("ConfigService"),
        n = e.validate(t),
        r = n.missing,
        o = n.invalid;
      if (0 === r.length && 0 === o.length) e.setConfig(t);else {
        var i = this.serviceFactory.getService("LoggingService"),
          s = "RUM Agent isn't correctly configured: ";
        0 < r.length && (s += "Missing config - " + r.join(", "), 0 < o.length && (s += ", ")), o.forEach(function (t, e) {
          var n = t.key,
            r = t.value,
            i = t.allowed;
          s += n + ' "' + r + '" contains invalid characters! (allowed: ' + i + ")" + (e !== o.length - 1 ? ", " : "");
        }), i.error(s), e.setConfig({
          active: !1
        });
      }
    }, e.setIgnoreSpansForRoutes = function (t) {
      this.serviceFactory.getService("ConfigService").setIgnoreSpansForRoutes(t);
    }, e.setUserContext = function (t) {
      this.serviceFactory.getService("ConfigService").setUserContext(t);
    }, e.setCustomContext = function (t) {
      this.serviceFactory.getService("ConfigService").setCustomContext(t);
    }, e.addTags = function (t) {
      this.serviceFactory.getService("LoggingService").warn("addTags deprecated, please use addLabels"), this.addLabels(t);
    }, e.addLabels = function (t) {
      this.serviceFactory.getService("ConfigService").addLabels(t);
    }, e.setInitialPageLoadName = function (t) {
      this.isEnabled() && this.serviceFactory.getService("ConfigService").setConfig({
        pageLoadTransactionName: t
      });
    }, e.startTransaction = function (t, e, n) {
      if (this.isEnabled()) return this.serviceFactory.getService("TransactionService").startTransaction(t, e, n);
    }, e.startSpan = function (t, e) {
      if (this.isEnabled()) return this.serviceFactory.getService("TransactionService").startSpan(t, e);
    }, e.getCurrentTransaction = function () {
      if (this.isEnabled()) return this.serviceFactory.getService("TransactionService").getCurrentTransaction();
    }, e.getTransactionService = function () {
      if (this.isEnabled()) return this.serviceFactory.getService("TransactionService");
    }, e.addFilter = function (t) {
      this.serviceFactory.getService("ConfigService").addFilter(t);
    }, t;
  }();
  n.d(e, "init", function () {
    return Qt;
  }), n.d(e, "apmBase", function () {
    return Ht;
  }), n.d(e, "apm", function () {
    return Ht;
  }), n.d(e, "ApmBase", function () {
    return Mt;
  });
  var jt,
    qt = (rt || (rt = !0, d() ? (nt(), it = !0) : "undefined" != typeof window && console.log("APM: Platform is not supported!")), it),
    Nt = ((jt = new Ft()).registerCoreServices(), Ct(jt), jt),
    Ht = new Mt(Nt, !qt);
  "undefined" != typeof window && window.atatus && (window.atatus.spa = Ht, window.atatus.VERSION && (window.atatus.VERSION += "-spa"));
  var Qt = Ht.init.bind(Ht);
  e.default = Qt;
}]);